import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, mapTo } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EmailBuilderTemplateFocuses = /*#__PURE__*/function (EmailBuilderTemplateFocuses) {
  EmailBuilderTemplateFocuses[EmailBuilderTemplateFocuses["EMAIL_BUILDER_TEMPLATE_FOCUSES_UNSPECIFIED"] = 0] = "EMAIL_BUILDER_TEMPLATE_FOCUSES_UNSPECIFIED";
  EmailBuilderTemplateFocuses[EmailBuilderTemplateFocuses["EMAIL_BUILDER_TEMPLATE_FOCUSES_ACQUIRE"] = 1] = "EMAIL_BUILDER_TEMPLATE_FOCUSES_ACQUIRE";
  EmailBuilderTemplateFocuses[EmailBuilderTemplateFocuses["EMAIL_BUILDER_TEMPLATE_FOCUSES_UPSELL"] = 2] = "EMAIL_BUILDER_TEMPLATE_FOCUSES_UPSELL";
  EmailBuilderTemplateFocuses[EmailBuilderTemplateFocuses["EMAIL_BUILDER_TEMPLATE_FOCUSES_ADOPT"] = 3] = "EMAIL_BUILDER_TEMPLATE_FOCUSES_ADOPT";
  return EmailBuilderTemplateFocuses;
}(EmailBuilderTemplateFocuses || {});
var ImageAlign = /*#__PURE__*/function (ImageAlign) {
  ImageAlign[ImageAlign["IMAGE_ALIGN_UNSPECIFIED"] = 0] = "IMAGE_ALIGN_UNSPECIFIED";
  ImageAlign[ImageAlign["IMAGE_ALIGN_LEFT"] = 1] = "IMAGE_ALIGN_LEFT";
  ImageAlign[ImageAlign["IMAGE_ALIGN_CENTER"] = 2] = "IMAGE_ALIGN_CENTER";
  ImageAlign[ImageAlign["IMAGE_ALIGN_RIGHT"] = 3] = "IMAGE_ALIGN_RIGHT";
  return ImageAlign;
}(ImageAlign || {});
var EmailBuilderTemplateStatuses = /*#__PURE__*/function (EmailBuilderTemplateStatuses) {
  EmailBuilderTemplateStatuses[EmailBuilderTemplateStatuses["EMAIL_BUILDER_TEMPLATE_STATUSES_UNSPECIFIED"] = 0] = "EMAIL_BUILDER_TEMPLATE_STATUSES_UNSPECIFIED";
  EmailBuilderTemplateStatuses[EmailBuilderTemplateStatuses["EMAIL_BUILDER_TEMPLATE_STATUSES_DRAFT"] = 1] = "EMAIL_BUILDER_TEMPLATE_STATUSES_DRAFT";
  EmailBuilderTemplateStatuses[EmailBuilderTemplateStatuses["EMAIL_BUILDER_TEMPLATE_STATUSES_PUBLISHED"] = 2] = "EMAIL_BUILDER_TEMPLATE_STATUSES_PUBLISHED";
  EmailBuilderTemplateStatuses[EmailBuilderTemplateStatuses["EMAIL_BUILDER_TEMPLATE_STATUSES_ACTIVE"] = 3] = "EMAIL_BUILDER_TEMPLATE_STATUSES_ACTIVE";
  EmailBuilderTemplateStatuses[EmailBuilderTemplateStatuses["EMAIL_BUILDER_TEMPLATE_STATUSES_ARCHIVED"] = 4] = "EMAIL_BUILDER_TEMPLATE_STATUSES_ARCHIVED";
  return EmailBuilderTemplateStatuses;
}(EmailBuilderTemplateStatuses || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DateDefault = /*#__PURE__*/function (DateDefault) {
  DateDefault[DateDefault["DATE_DEFAULT_INVALID"] = 0] = "DATE_DEFAULT_INVALID";
  DateDefault[DateDefault["DATE_DEFAULT_TODAY"] = 1] = "DATE_DEFAULT_TODAY";
  DateDefault[DateDefault["DATE_DEFAULT_YESTERDAY"] = 2] = "DATE_DEFAULT_YESTERDAY";
  DateDefault[DateDefault["DATE_DEFAULT_TOMORROW"] = 3] = "DATE_DEFAULT_TOMORROW";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_WEEK"] = 4] = "DATE_DEFAULT_THIS_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_WEEK"] = 5] = "DATE_DEFAULT_LAST_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_WEEK"] = 6] = "DATE_DEFAULT_NEXT_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_MONTH"] = 7] = "DATE_DEFAULT_THIS_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_MONTH"] = 8] = "DATE_DEFAULT_LAST_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_MONTH"] = 9] = "DATE_DEFAULT_NEXT_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_QUARTER"] = 10] = "DATE_DEFAULT_THIS_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_QUARTER"] = 11] = "DATE_DEFAULT_LAST_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_QUARTER"] = 12] = "DATE_DEFAULT_NEXT_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_YEAR"] = 13] = "DATE_DEFAULT_THIS_YEAR";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_YEAR"] = 14] = "DATE_DEFAULT_LAST_YEAR";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_YEAR"] = 15] = "DATE_DEFAULT_NEXT_YEAR";
  return DateDefault;
}(DateDefault || {});
var FilterGroupOperator = /*#__PURE__*/function (FilterGroupOperator) {
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_INVALID"] = 0] = "FILTER_GROUP_OPERATOR_INVALID";
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_AND"] = 1] = "FILTER_GROUP_OPERATOR_AND";
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_OR"] = 2] = "FILTER_GROUP_OPERATOR_OR";
  return FilterGroupOperator;
}(FilterGroupOperator || {});
var FilterOperator = /*#__PURE__*/function (FilterOperator) {
  FilterOperator[FilterOperator["FILTER_OPERATOR_INVALID"] = 0] = "FILTER_OPERATOR_INVALID";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_EMPTY"] = 1] = "FILTER_OPERATOR_IS_EMPTY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_EMPTY"] = 2] = "FILTER_OPERATOR_IS_NOT_EMPTY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS"] = 3] = "FILTER_OPERATOR_IS";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT"] = 4] = "FILTER_OPERATOR_IS_NOT";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_ANY"] = 5] = "FILTER_OPERATOR_IS_ANY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_ANY"] = 6] = "FILTER_OPERATOR_IS_NOT_ANY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_ALL"] = 7] = "FILTER_OPERATOR_IS_ALL";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_ALL"] = 8] = "FILTER_OPERATOR_IS_NOT_ALL";
  FilterOperator[FilterOperator["FILTER_OPERATOR_CONTAINS"] = 9] = "FILTER_OPERATOR_CONTAINS";
  FilterOperator[FilterOperator["FILTER_OPERATOR_DOES_NOT_CONTAIN"] = 10] = "FILTER_OPERATOR_DOES_NOT_CONTAIN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_EQUAL_TO"] = 11] = "FILTER_OPERATOR_IS_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_EQUAL_TO"] = 12] = "FILTER_OPERATOR_IS_NOT_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_GREATER_THAN"] = 13] = "FILTER_OPERATOR_IS_GREATER_THAN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO"] = 14] = "FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_LESS_THAN"] = 15] = "FILTER_OPERATOR_IS_LESS_THAN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO"] = 16] = "FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BEFORE"] = 17] = "FILTER_OPERATOR_IS_BEFORE";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BEFORE_OR_ON"] = 18] = "FILTER_OPERATOR_IS_BEFORE_OR_ON";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_AFTER"] = 19] = "FILTER_OPERATOR_IS_AFTER";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_AFTER_OR_ON"] = 20] = "FILTER_OPERATOR_IS_AFTER_OR_ON";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BETWEEN"] = 21] = "FILTER_OPERATOR_IS_BETWEEN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_BETWEEN"] = 22] = "FILTER_OPERATOR_IS_NOT_BETWEEN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_VALID"] = 23] = "FILTER_OPERATOR_IS_VALID";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_VALID"] = 24] = "FILTER_OPERATOR_IS_NOT_VALID";
  return FilterOperator;
}(FilterOperator || {});
var FilterType = /*#__PURE__*/function (FilterType) {
  FilterType[FilterType["FILTER_TYPE_INVALID"] = 0] = "FILTER_TYPE_INVALID";
  FilterType[FilterType["FILTER_TYPE_STRING"] = 1] = "FILTER_TYPE_STRING";
  FilterType[FilterType["FILTER_TYPE_INTEGER"] = 2] = "FILTER_TYPE_INTEGER";
  FilterType[FilterType["FILTER_TYPE_DATE"] = 3] = "FILTER_TYPE_DATE";
  FilterType[FilterType["FILTER_TYPE_FLOAT"] = 4] = "FILTER_TYPE_FLOAT";
  FilterType[FilterType["FILTER_TYPE_BOOLEAN"] = 5] = "FILTER_TYPE_BOOLEAN";
  FilterType[FilterType["FILTER_TYPE_TAG"] = 6] = "FILTER_TYPE_TAG";
  FilterType[FilterType["FILTER_TYPE_PHONE"] = 8] = "FILTER_TYPE_PHONE";
  return FilterType;
}(FilterType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AsyncWorkStatus = /*#__PURE__*/function (AsyncWorkStatus) {
  AsyncWorkStatus[AsyncWorkStatus["ASYNC_WORK_STATUS_INVALID"] = 0] = "ASYNC_WORK_STATUS_INVALID";
  AsyncWorkStatus[AsyncWorkStatus["ASYNC_WORK_STATUS_IN_PROGRESS"] = 1] = "ASYNC_WORK_STATUS_IN_PROGRESS";
  AsyncWorkStatus[AsyncWorkStatus["ASYNC_WORK_STATUS_COMPLETE"] = 2] = "ASYNC_WORK_STATUS_COMPLETE";
  AsyncWorkStatus[AsyncWorkStatus["ASYNC_WORK_STATUS_ERROR"] = 3] = "ASYNC_WORK_STATUS_ERROR";
  return AsyncWorkStatus;
}(AsyncWorkStatus || {});
var CampaignQuotaCategory = /*#__PURE__*/function (CampaignQuotaCategory) {
  CampaignQuotaCategory[CampaignQuotaCategory["CAMPAIGN_QUOTA_TYPE_INVALID"] = 0] = "CAMPAIGN_QUOTA_TYPE_INVALID";
  CampaignQuotaCategory[CampaignQuotaCategory["CAMPAIGN_QUOTA_TYPE_EMAIL"] = 1] = "CAMPAIGN_QUOTA_TYPE_EMAIL";
  CampaignQuotaCategory[CampaignQuotaCategory["CAMPAIGN_QUOTA_TYPE_SMS"] = 2] = "CAMPAIGN_QUOTA_TYPE_SMS";
  return CampaignQuotaCategory;
}(CampaignQuotaCategory || {});
var CampaignScheduleStatus = /*#__PURE__*/function (CampaignScheduleStatus) {
  CampaignScheduleStatus[CampaignScheduleStatus["CAMPAIGN_SCHEDULE_STATUS_UNSPECIFIED"] = 0] = "CAMPAIGN_SCHEDULE_STATUS_UNSPECIFIED";
  CampaignScheduleStatus[CampaignScheduleStatus["CAMPAIGN_SCHEDULE_STATUS_ACTIVE"] = 1] = "CAMPAIGN_SCHEDULE_STATUS_ACTIVE";
  CampaignScheduleStatus[CampaignScheduleStatus["CAMPAIGN_SCHEDULE_STATUS_WAITING_ON_RATE_LIMIT"] = 2] = "CAMPAIGN_SCHEDULE_STATUS_WAITING_ON_RATE_LIMIT";
  CampaignScheduleStatus[CampaignScheduleStatus["CAMPAIGN_SCHEDULE_STATUS_STOPPED"] = 3] = "CAMPAIGN_SCHEDULE_STATUS_STOPPED";
  CampaignScheduleStatus[CampaignScheduleStatus["CAMPAIGN_SCHEDULE_STATUS_COMPLETED"] = 4] = "CAMPAIGN_SCHEDULE_STATUS_COMPLETED";
  return CampaignScheduleStatus;
}(CampaignScheduleStatus || {});
var CampaignState = /*#__PURE__*/function (CampaignState) {
  CampaignState[CampaignState["CAMPAIGN_STATE_UNSPECIFIED"] = 0] = "CAMPAIGN_STATE_UNSPECIFIED";
  CampaignState[CampaignState["CAMPAIGN_STATE_ACTIVE"] = 1] = "CAMPAIGN_STATE_ACTIVE";
  CampaignState[CampaignState["CAMPAIGN_STATE_IDLE"] = 2] = "CAMPAIGN_STATE_IDLE";
  return CampaignState;
}(CampaignState || {});
var CampaignStepEventType = /*#__PURE__*/function (CampaignStepEventType) {
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_UNSPECIFIED"] = 0] = "CAMPAIGN_STEP_EVENT_TYPE_UNSPECIFIED";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_PROCESSED"] = 1] = "CAMPAIGN_STEP_EVENT_TYPE_PROCESSED";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_DROPPED"] = 2] = "CAMPAIGN_STEP_EVENT_TYPE_DROPPED";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_DELIVERED"] = 3] = "CAMPAIGN_STEP_EVENT_TYPE_DELIVERED";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_DEFERRED"] = 4] = "CAMPAIGN_STEP_EVENT_TYPE_DEFERRED";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_BOUNCE"] = 5] = "CAMPAIGN_STEP_EVENT_TYPE_BOUNCE";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_OPEN"] = 6] = "CAMPAIGN_STEP_EVENT_TYPE_OPEN";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_CLICK"] = 7] = "CAMPAIGN_STEP_EVENT_TYPE_CLICK";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_SPAM_REPORT"] = 8] = "CAMPAIGN_STEP_EVENT_TYPE_SPAM_REPORT";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_UNSUBSCRIBE"] = 9] = "CAMPAIGN_STEP_EVENT_TYPE_UNSUBSCRIBE";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_CREATED"] = 10] = "CAMPAIGN_STEP_EVENT_TYPE_CREATED";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_NOT_REQUIRED"] = 11] = "CAMPAIGN_STEP_EVENT_TYPE_NOT_REQUIRED";
  CampaignStepEventType[CampaignStepEventType["CAMPAIGN_STEP_EVENT_TYPE_REFRESHED"] = 12] = "CAMPAIGN_STEP_EVENT_TYPE_REFRESHED";
  return CampaignStepEventType;
}(CampaignStepEventType || {});
var CampaignStepSendStatusType = /*#__PURE__*/function (CampaignStepSendStatusType) {
  CampaignStepSendStatusType[CampaignStepSendStatusType["CAMPAIGN_STEP_SEND_STATUS_TYPE_UNSPECIFIED"] = 0] = "CAMPAIGN_STEP_SEND_STATUS_TYPE_UNSPECIFIED";
  CampaignStepSendStatusType[CampaignStepSendStatusType["CAMPAIGN_STEP_SEND_STATUS_TYPE_UNSENT"] = 1] = "CAMPAIGN_STEP_SEND_STATUS_TYPE_UNSENT";
  CampaignStepSendStatusType[CampaignStepSendStatusType["CAMPAIGN_STEP_SEND_STATUS_TYPE_QUEUED"] = 2] = "CAMPAIGN_STEP_SEND_STATUS_TYPE_QUEUED";
  CampaignStepSendStatusType[CampaignStepSendStatusType["CAMPAIGN_STEP_SEND_STATUS_TYPE_SENDING"] = 3] = "CAMPAIGN_STEP_SEND_STATUS_TYPE_SENDING";
  CampaignStepSendStatusType[CampaignStepSendStatusType["CAMPAIGN_STEP_SEND_STATUS_TYPE_SENT"] = 4] = "CAMPAIGN_STEP_SEND_STATUS_TYPE_SENT";
  return CampaignStepSendStatusType;
}(CampaignStepSendStatusType || {});
var CampaignStepType = /*#__PURE__*/function (CampaignStepType) {
  CampaignStepType[CampaignStepType["CAMPAIGN_STEP_TYPE_UNSPECIFIED"] = 0] = "CAMPAIGN_STEP_TYPE_UNSPECIFIED";
  CampaignStepType[CampaignStepType["CAMPAIGN_STEP_TYPE_EMAIL"] = 1] = "CAMPAIGN_STEP_TYPE_EMAIL";
  CampaignStepType[CampaignStepType["CAMPAIGN_STEP_TYPE_SNAPSHOT_CREATION"] = 2] = "CAMPAIGN_STEP_TYPE_SNAPSHOT_CREATION";
  CampaignStepType[CampaignStepType["CAMPAIGN_STEP_TYPE_SMS"] = 3] = "CAMPAIGN_STEP_TYPE_SMS";
  return CampaignStepType;
}(CampaignStepType || {});
var ContactType = /*#__PURE__*/function (ContactType) {
  ContactType[ContactType["CONTACT_TYPE_INVALID"] = 0] = "CONTACT_TYPE_INVALID";
  ContactType[ContactType["CONTACT_TYPE_EMAIL"] = 1] = "CONTACT_TYPE_EMAIL";
  return ContactType;
}(ContactType || {});
var DaysOfTheWeek = /*#__PURE__*/function (DaysOfTheWeek) {
  DaysOfTheWeek[DaysOfTheWeek["DAYS_OF_THE_WEEK_MONDAY"] = 0] = "DAYS_OF_THE_WEEK_MONDAY";
  DaysOfTheWeek[DaysOfTheWeek["DAYS_OF_THE_WEEK_TUESDAY"] = 1] = "DAYS_OF_THE_WEEK_TUESDAY";
  DaysOfTheWeek[DaysOfTheWeek["DAYS_OF_THE_WEEK_WEDNESDAY"] = 2] = "DAYS_OF_THE_WEEK_WEDNESDAY";
  DaysOfTheWeek[DaysOfTheWeek["DAYS_OF_THE_WEEK_THURSDAY"] = 3] = "DAYS_OF_THE_WEEK_THURSDAY";
  DaysOfTheWeek[DaysOfTheWeek["DAYS_OF_THE_WEEK_FRIDAY"] = 4] = "DAYS_OF_THE_WEEK_FRIDAY";
  DaysOfTheWeek[DaysOfTheWeek["DAYS_OF_THE_WEEK_SATURDAY"] = 5] = "DAYS_OF_THE_WEEK_SATURDAY";
  DaysOfTheWeek[DaysOfTheWeek["DAYS_OF_THE_WEEK_SUNDAY"] = 6] = "DAYS_OF_THE_WEEK_SUNDAY";
  return DaysOfTheWeek;
}(DaysOfTheWeek || {});
var DeletedTagsPolicy = /*#__PURE__*/function (DeletedTagsPolicy) {
  DeletedTagsPolicy[DeletedTagsPolicy["DELETED_TAGS_POLICY_EXCLUDE_FROM_RESPONSE"] = 0] = "DELETED_TAGS_POLICY_EXCLUDE_FROM_RESPONSE";
  return DeletedTagsPolicy;
}(DeletedTagsPolicy || {});
var DuplicateCampaignStepStatus = /*#__PURE__*/function (DuplicateCampaignStepStatus) {
  DuplicateCampaignStepStatus[DuplicateCampaignStepStatus["DUPLICATE_CAMPAIGN_STEP_STATUS_INVALID"] = 0] = "DUPLICATE_CAMPAIGN_STEP_STATUS_INVALID";
  DuplicateCampaignStepStatus[DuplicateCampaignStepStatus["DUPLICATE_CAMPAIGN_STEP_STATUS_IN_PROGRESS"] = 1] = "DUPLICATE_CAMPAIGN_STEP_STATUS_IN_PROGRESS";
  DuplicateCampaignStepStatus[DuplicateCampaignStepStatus["DUPLICATE_CAMPAIGN_STEP_STATUS_COMPLETE"] = 2] = "DUPLICATE_CAMPAIGN_STEP_STATUS_COMPLETE";
  return DuplicateCampaignStepStatus;
}(DuplicateCampaignStepStatus || {});
var Feature = /*#__PURE__*/function (Feature) {
  Feature[Feature["SEND_UNKNOWN"] = 0] = "SEND_UNKNOWN";
  Feature[Feature["SEND_SMS"] = 1] = "SEND_SMS";
  Feature[Feature["SEND_EMAIL"] = 2] = "SEND_EMAIL";
  Feature[Feature["SEND_SNAPSHOT"] = 3] = "SEND_SNAPSHOT";
  Feature[Feature["SEND_EMAIL_ADDONS"] = 4] = "SEND_EMAIL_ADDONS";
  return Feature;
}(Feature || {});
var Focuses = /*#__PURE__*/function (Focuses) {
  Focuses[Focuses["FOCUSES_UNSPECIFIED"] = 0] = "FOCUSES_UNSPECIFIED";
  Focuses[Focuses["FOCUSES_ACQUIRE"] = 1] = "FOCUSES_ACQUIRE";
  Focuses[Focuses["FOCUSES_UPSELL"] = 2] = "FOCUSES_UPSELL";
  Focuses[Focuses["FOCUSES_ADOPT"] = 3] = "FOCUSES_ADOPT";
  Focuses[Focuses["FOCUSES_NONE"] = 4] = "FOCUSES_NONE";
  return Focuses;
}(Focuses || {});
var Period = /*#__PURE__*/function (Period) {
  Period[Period["PERIOD_INVALID"] = 0] = "PERIOD_INVALID";
  Period[Period["PERIOD_MONTH"] = 1] = "PERIOD_MONTH";
  return Period;
}(Period || {});
var RecipientCampaignStatus = /*#__PURE__*/function (RecipientCampaignStatus) {
  RecipientCampaignStatus[RecipientCampaignStatus["RECIPIENT_CAMPAIGN_STATUS_UNSPECIFIED"] = 0] = "RECIPIENT_CAMPAIGN_STATUS_UNSPECIFIED";
  RecipientCampaignStatus[RecipientCampaignStatus["RECIPIENT_CAMPAIGN_STATUS_ACTIVE"] = 1] = "RECIPIENT_CAMPAIGN_STATUS_ACTIVE";
  RecipientCampaignStatus[RecipientCampaignStatus["RECIPIENT_CAMPAIGN_STATUS_PAUSED"] = 2] = "RECIPIENT_CAMPAIGN_STATUS_PAUSED";
  RecipientCampaignStatus[RecipientCampaignStatus["RECIPIENT_CAMPAIGN_STATUS_COMPLETED"] = 3] = "RECIPIENT_CAMPAIGN_STATUS_COMPLETED";
  return RecipientCampaignStatus;
}(RecipientCampaignStatus || {});
var RecipientType = /*#__PURE__*/function (RecipientType) {
  RecipientType[RecipientType["RECIPIENT_TYPE_INVALID"] = 0] = "RECIPIENT_TYPE_INVALID";
  RecipientType[RecipientType["RECIPIENT_TYPE_CRM_CONTACT"] = 1] = "RECIPIENT_TYPE_CRM_CONTACT";
  RecipientType[RecipientType["RECIPIENT_TYPE_BUSINESS"] = 2] = "RECIPIENT_TYPE_BUSINESS";
  return RecipientType;
}(RecipientType || {});
var SenderType = /*#__PURE__*/function (SenderType) {
  SenderType[SenderType["SENDER_TYPE_INVALID"] = 0] = "SENDER_TYPE_INVALID";
  SenderType[SenderType["SENDER_TYPE_PARTNER"] = 1] = "SENDER_TYPE_PARTNER";
  SenderType[SenderType["SENDER_TYPE_BUSINESS"] = 2] = "SENDER_TYPE_BUSINESS";
  return SenderType;
}(SenderType || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_ORDER_INVALID"] = 0] = "SORT_ORDER_INVALID";
  SortDirection[SortDirection["SORT_ORDER_ASCENDING"] = 1] = "SORT_ORDER_ASCENDING";
  SortDirection[SortDirection["SORT_ORDER_DESCENDING"] = 2] = "SORT_ORDER_DESCENDING";
  return SortDirection;
}(SortDirection || {});
var SortField = /*#__PURE__*/function (SortField) {
  SortField[SortField["SORT_FIELDS_INVALID"] = 0] = "SORT_FIELDS_INVALID";
  SortField[SortField["SORT_FIELDS_NAME"] = 1] = "SORT_FIELDS_NAME";
  SortField[SortField["SORT_FIELDS_CREATED_AT"] = 2] = "SORT_FIELDS_CREATED_AT";
  SortField[SortField["SORT_FIELDS_UPDATED_AT"] = 3] = "SORT_FIELDS_UPDATED_AT";
  return SortField;
}(SortField || {});
var Statuses = /*#__PURE__*/function (Statuses) {
  Statuses[Statuses["STATUSES_UNSPECIFIED"] = 0] = "STATUSES_UNSPECIFIED";
  Statuses[Statuses["STATUSES_DRAFT"] = 1] = "STATUSES_DRAFT";
  Statuses[Statuses["STATUSES_PUBLISHED"] = 2] = "STATUSES_PUBLISHED";
  Statuses[Statuses["STATUSES_ACTIVE"] = 3] = "STATUSES_ACTIVE";
  Statuses[Statuses["STATUSES_ARCHIVED"] = 4] = "STATUSES_ARCHIVED";
  return Statuses;
}(Statuses || {});
var TemplateStatus = /*#__PURE__*/function (TemplateStatus) {
  TemplateStatus[TemplateStatus["TEMPLATE_STATUS_INVALID"] = 0] = "TEMPLATE_STATUS_INVALID";
  TemplateStatus[TemplateStatus["TEMPLATE_STATUS_DRAFT"] = 1] = "TEMPLATE_STATUS_DRAFT";
  TemplateStatus[TemplateStatus["TEMPLATE_STATUS_PUBLISHED"] = 2] = "TEMPLATE_STATUS_PUBLISHED";
  return TemplateStatus;
}(TemplateStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Colors {
  static fromProto(proto) {
    let m = new Colors();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.textColor !== 'undefined') {
      toReturn['textColor'] = this.textColor;
    }
    if (typeof this.titleColor !== 'undefined') {
      toReturn['titleColor'] = this.titleColor;
    }
    if (typeof this.subtitleColor !== 'undefined') {
      toReturn['subtitleColor'] = this.subtitleColor;
    }
    if (typeof this.linkColor !== 'undefined') {
      toReturn['linkColor'] = this.linkColor;
    }
    if (typeof this.footerTextColor !== 'undefined') {
      toReturn['footerTextColor'] = this.footerTextColor;
    }
    if (typeof this.textBackground !== 'undefined') {
      toReturn['textBackground'] = this.textBackground;
    }
    if (typeof this.pageBackground !== 'undefined') {
      toReturn['pageBackground'] = this.pageBackground;
    }
    return toReturn;
  }
}
class EmailBuilderConfiguration {
  static fromProto(proto) {
    let m = new EmailBuilderConfiguration();
    m = Object.assign(m, proto);
    if (proto.googleAnalyticsOptions) {
      m.googleAnalyticsOptions = GoogleAnalyticsOptions.fromProto(proto.googleAnalyticsOptions);
    }
    if (proto.pageSetup) {
      m.pageSetup = PageSetup.fromProto(proto.pageSetup);
    }
    if (proto.topLogo) {
      m.topLogo = TopLogo.fromProto(proto.topLogo);
    }
    if (proto.footer) {
      m.footer = Footer.fromProto(proto.footer);
    }
    if (proto.colors) {
      m.colors = Colors.fromProto(proto.colors);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleAnalyticsOptions !== 'undefined' && this.googleAnalyticsOptions !== null) {
      toReturn['googleAnalyticsOptions'] = 'toApiJson' in this.googleAnalyticsOptions ? this.googleAnalyticsOptions.toApiJson() : this.googleAnalyticsOptions;
    }
    if (typeof this.pageSetup !== 'undefined' && this.pageSetup !== null) {
      toReturn['pageSetup'] = 'toApiJson' in this.pageSetup ? this.pageSetup.toApiJson() : this.pageSetup;
    }
    if (typeof this.topLogo !== 'undefined' && this.topLogo !== null) {
      toReturn['topLogo'] = 'toApiJson' in this.topLogo ? this.topLogo.toApiJson() : this.topLogo;
    }
    if (typeof this.footer !== 'undefined' && this.footer !== null) {
      toReturn['footer'] = 'toApiJson' in this.footer ? this.footer.toApiJson() : this.footer;
    }
    if (typeof this.contentBlocks !== 'undefined') {
      toReturn['contentBlocks'] = this.contentBlocks;
    }
    if (typeof this.colors !== 'undefined' && this.colors !== null) {
      toReturn['colors'] = 'toApiJson' in this.colors ? this.colors.toApiJson() : this.colors;
    }
    return toReturn;
  }
}
class EmailBuilderTemplate {
  static fromProto(proto) {
    let m = new EmailBuilderTemplate();
    m = Object.assign(m, proto);
    if (proto.emailBuilderConfiguration) {
      m.emailBuilderConfiguration = EmailBuilderConfiguration.fromProto(proto.emailBuilderConfiguration);
    }
    if (proto.campaignFocus) {
      m.campaignFocus = enumStringToValue$4(EmailBuilderTemplateFocuses, proto.campaignFocus);
    }
    if (proto.status) {
      m.status = enumStringToValue$4(EmailBuilderTemplateStatuses, proto.status);
    }
    if (proto.parent) {
      m.parent = TemplateReference.fromProto(proto.parent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.subjectLine !== 'undefined') {
      toReturn['subjectLine'] = this.subjectLine;
    }
    if (typeof this.previewText !== 'undefined') {
      toReturn['previewText'] = this.previewText;
    }
    if (typeof this.lastModifiedBy !== 'undefined') {
      toReturn['lastModifiedBy'] = this.lastModifiedBy;
    }
    if (typeof this.emailBuilderConfiguration !== 'undefined' && this.emailBuilderConfiguration !== null) {
      toReturn['emailBuilderConfiguration'] = 'toApiJson' in this.emailBuilderConfiguration ? this.emailBuilderConfiguration.toApiJson() : this.emailBuilderConfiguration;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.campaignFocus !== 'undefined') {
      toReturn['campaignFocus'] = this.campaignFocus;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.isEditable !== 'undefined') {
      toReturn['isEditable'] = this.isEditable;
    }
    if (typeof this.parent !== 'undefined' && this.parent !== null) {
      toReturn['parent'] = 'toApiJson' in this.parent ? this.parent.toApiJson() : this.parent;
    }
    return toReturn;
  }
}
class Footer {
  static fromProto(proto) {
    let m = new Footer();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.disclaimer !== 'undefined') {
      toReturn['disclaimer'] = this.disclaimer;
    }
    if (typeof this.showContactInfo !== 'undefined') {
      toReturn['showContactInfo'] = this.showContactInfo;
    }
    if (typeof this.showUnsubscribeLinks !== 'undefined') {
      toReturn['showUnsubscribeLinks'] = this.showUnsubscribeLinks;
    }
    return toReturn;
  }
}
class GoogleAnalyticsOptions {
  static fromProto(proto) {
    let m = new GoogleAnalyticsOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignName !== 'undefined') {
      toReturn['campaignName'] = this.campaignName;
    }
    if (typeof this.campaignSource !== 'undefined') {
      toReturn['campaignSource'] = this.campaignSource;
    }
    return toReturn;
  }
}
class PageSetup {
  static fromProto(proto) {
    let m = new PageSetup();
    m = Object.assign(m, proto);
    if (proto.outerWidth) {
      m.outerWidth = parseInt(proto.outerWidth, 10);
    }
    if (proto.innerWidth) {
      m.innerWidth = parseInt(proto.innerWidth, 10);
    }
    if (proto.topPadding) {
      m.topPadding = parseInt(proto.topPadding, 10);
    }
    if (proto.bottomContentPadding) {
      m.bottomContentPadding = parseInt(proto.bottomContentPadding, 10);
    }
    if (proto.innerHorizontalPadding) {
      m.innerHorizontalPadding = parseInt(proto.innerHorizontalPadding, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.outerWidth !== 'undefined') {
      toReturn['outerWidth'] = this.outerWidth;
    }
    if (typeof this.innerWidth !== 'undefined') {
      toReturn['innerWidth'] = this.innerWidth;
    }
    if (typeof this.topPadding !== 'undefined') {
      toReturn['topPadding'] = this.topPadding;
    }
    if (typeof this.bottomContentPadding !== 'undefined') {
      toReturn['bottomContentPadding'] = this.bottomContentPadding;
    }
    if (typeof this.innerHorizontalPadding !== 'undefined') {
      toReturn['innerHorizontalPadding'] = this.innerHorizontalPadding;
    }
    return toReturn;
  }
}
class TemplateReference {
  static fromProto(proto) {
    let m = new TemplateReference();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class TopLogo {
  static fromProto(proto) {
    let m = new TopLogo();
    m = Object.assign(m, proto);
    if (proto.width) {
      m.width = parseInt(proto.width, 10);
    }
    if (proto.align) {
      m.align = enumStringToValue$4(ImageAlign, proto.align);
    }
    if (proto.topPadding) {
      m.topPadding = parseInt(proto.topPadding, 10);
    }
    if (proto.bottomPadding) {
      m.bottomPadding = parseInt(proto.bottomPadding, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.showLogo !== 'undefined') {
      toReturn['showLogo'] = this.showLogo;
    }
    if (typeof this.customImageUrl !== 'undefined') {
      toReturn['customImageUrl'] = this.customImageUrl;
    }
    if (typeof this.width !== 'undefined') {
      toReturn['width'] = this.width;
    }
    if (typeof this.align !== 'undefined') {
      toReturn['align'] = this.align;
    }
    if (typeof this.topPadding !== 'undefined') {
      toReturn['topPadding'] = this.topPadding;
    }
    if (typeof this.bottomPadding !== 'undefined') {
      toReturn['bottomPadding'] = this.bottomPadding;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Filter {
  static fromProto(proto) {
    let m = new Filter();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$1(FilterOperator, proto.operator);
    }
    if (proto.values) {
      m.values = proto.values.map(FilterValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? this.values.toApiJson() : this.values;
    }
    if (typeof this.floatTolerance !== 'undefined') {
      toReturn['floatTolerance'] = this.floatTolerance;
    }
    return toReturn;
  }
}
class FilterGroup {
  static fromProto(proto) {
    let m = new FilterGroup();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$1(FilterGroupOperator, proto.operator);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(Filter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class Phone {
  static fromProto(proto) {
    let m = new Phone();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isoCountryCode !== 'undefined') {
      toReturn['isoCountryCode'] = this.isoCountryCode;
    }
    if (typeof this.nationalNumber !== 'undefined') {
      toReturn['nationalNumber'] = this.nationalNumber;
    }
    if (typeof this.extension !== 'undefined') {
      toReturn['extension'] = this.extension;
    }
    return toReturn;
  }
}
class FilterValue {
  static fromProto(proto) {
    let m = new FilterValue();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.dateDefault) {
      m.dateDefault = enumStringToValue$1(DateDefault, proto.dateDefault);
    }
    if (proto.phone) {
      m.phone = Phone.fromProto(proto.phone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.boolean !== 'undefined') {
      toReturn['boolean'] = this.boolean;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.float !== 'undefined') {
      toReturn['float'] = this.float;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.dateDefault !== 'undefined') {
      toReturn['dateDefault'] = this.dateDefault;
    }
    if (typeof this.phone !== 'undefined' && this.phone !== null) {
      toReturn['phone'] = 'toApiJson' in this.phone ? this.phone.toApiJson() : this.phone;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class RecipientClickStatsAccount {
  static fromProto(proto) {
    let m = new RecipientClickStatsAccount();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class ActivateProductForSenderRequest {
  static fromProto(proto) {
    let m = new ActivateProductForSenderRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class AddContactToCampaignRequest {
  static fromProto(proto) {
    let m = new AddContactToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.recipient) {
      m.recipient = RecipientV2.fromProto(proto.recipient);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.senderOptions) {
      m.senderOptions = SenderOptions.fromProto(proto.senderOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.senderOptions !== 'undefined' && this.senderOptions !== null) {
      toReturn['senderOptions'] = 'toApiJson' in this.senderOptions ? this.senderOptions.toApiJson() : this.senderOptions;
    }
    if (typeof this.sendNow !== 'undefined') {
      toReturn['sendNow'] = this.sendNow;
    }
    return toReturn;
  }
}
class AddContactToCampaignResponse {
  static fromProto(proto) {
    let m = new AddContactToCampaignResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    return toReturn;
  }
}
class AddStepToCampaignRequest {
  static fromProto(proto) {
    let m = new AddStepToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.stepType) {
      m.stepType = enumStringToValue(CampaignStepType, proto.stepType);
    }
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.stepType !== 'undefined') {
      toReturn['stepType'] = this.stepType;
    }
    if (typeof this.contentId !== 'undefined') {
      toReturn['contentId'] = this.contentId;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class AddTagToCampaignRequest {
  static fromProto(proto) {
    let m = new AddTagToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    return toReturn;
  }
}
class BulkAddContactIdsToCampaignRequest {
  static fromProto(proto) {
    let m = new BulkAddContactIdsToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.contactIds !== 'undefined') {
      toReturn['contactIds'] = this.contactIds;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    return toReturn;
  }
}
class BulkAddContactsToCampaignRequest {
  static fromProto(proto) {
    let m = new BulkAddContactsToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.criteria) {
      m.criteria = RecipientCriteria.fromProto(proto.criteria);
    }
    if (proto.senderOptions) {
      m.senderOptions = SenderOptions.fromProto(proto.senderOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.criteria !== 'undefined' && this.criteria !== null) {
      toReturn['criteria'] = 'toApiJson' in this.criteria ? this.criteria.toApiJson() : this.criteria;
    }
    if (typeof this.senderOptions !== 'undefined' && this.senderOptions !== null) {
      toReturn['senderOptions'] = 'toApiJson' in this.senderOptions ? this.senderOptions.toApiJson() : this.senderOptions;
    }
    if (typeof this.sendNow !== 'undefined') {
      toReturn['sendNow'] = this.sendNow;
    }
    return toReturn;
  }
}
class CampaignDetailStats {
  static fromProto(proto) {
    let m = new CampaignDetailStats();
    m = Object.assign(m, proto);
    if (proto.active) {
      m.active = parseInt(proto.active, 10);
    }
    if (proto.clicksPerOpenedEmail) {
      m.clicksPerOpenedEmail = parseInt(proto.clicksPerOpenedEmail, 10);
    }
    if (proto.completed) {
      m.completed = parseInt(proto.completed, 10);
    }
    if (proto.delivered) {
      m.delivered = parseInt(proto.delivered, 10);
    }
    if (proto.opened) {
      m.opened = parseInt(proto.opened, 10);
    }
    if (proto.sent) {
      m.sent = parseInt(proto.sent, 10);
    }
    if (proto.stopped) {
      m.stopped = parseInt(proto.stopped, 10);
    }
    if (proto.totalAccounts) {
      m.totalAccounts = parseInt(proto.totalAccounts, 10);
    }
    if (proto.totalLeads) {
      m.totalLeads = parseInt(proto.totalLeads, 10);
    }
    if (proto.totalRecipients) {
      m.totalRecipients = parseInt(proto.totalRecipients, 10);
    }
    if (proto.undeliverable) {
      m.undeliverable = parseInt(proto.undeliverable, 10);
    }
    if (proto.waitingOnRateLimit) {
      m.waitingOnRateLimit = parseInt(proto.waitingOnRateLimit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.active !== 'undefined') {
      toReturn['active'] = this.active;
    }
    if (typeof this.clicksPerOpenedEmail !== 'undefined') {
      toReturn['clicksPerOpenedEmail'] = this.clicksPerOpenedEmail;
    }
    if (typeof this.completed !== 'undefined') {
      toReturn['completed'] = this.completed;
    }
    if (typeof this.delivered !== 'undefined') {
      toReturn['delivered'] = this.delivered;
    }
    if (typeof this.opened !== 'undefined') {
      toReturn['opened'] = this.opened;
    }
    if (typeof this.sent !== 'undefined') {
      toReturn['sent'] = this.sent;
    }
    if (typeof this.stopped !== 'undefined') {
      toReturn['stopped'] = this.stopped;
    }
    if (typeof this.totalAccounts !== 'undefined') {
      toReturn['totalAccounts'] = this.totalAccounts;
    }
    if (typeof this.totalLeads !== 'undefined') {
      toReturn['totalLeads'] = this.totalLeads;
    }
    if (typeof this.totalRecipients !== 'undefined') {
      toReturn['totalRecipients'] = this.totalRecipients;
    }
    if (typeof this.undeliverable !== 'undefined') {
      toReturn['undeliverable'] = this.undeliverable;
    }
    if (typeof this.waitingOnRateLimit !== 'undefined') {
      toReturn['waitingOnRateLimit'] = this.waitingOnRateLimit;
    }
    return toReturn;
  }
}
class CampaignRecipient {
  static fromProto(proto) {
    let m = new CampaignRecipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class CampaignStepEvent {
  static fromProto(proto) {
    let m = new CampaignStepEvent();
    m = Object.assign(m, proto);
    if (proto.eventType) {
      m.eventType = enumStringToValue(CampaignStepEventType, proto.eventType);
    }
    if (proto.eventDate) {
      m.eventDate = new Date(proto.eventDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.eventDate !== 'undefined' && this.eventDate !== null) {
      toReturn['eventDate'] = 'toApiJson' in this.eventDate ? this.eventDate.toApiJson() : this.eventDate;
    }
    return toReturn;
  }
}
class CampaignStepInterface {
  static fromProto(proto) {
    let m = new CampaignStepInterface();
    m = Object.assign(m, proto);
    if (proto.stepType) {
      m.stepType = enumStringToValue(CampaignStepType, proto.stepType);
    }
    if (proto.secondsAfterLastEmail) {
      m.secondsAfterLastEmail = parseInt(proto.secondsAfterLastEmail, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.stepType !== 'undefined') {
      toReturn['stepType'] = this.stepType;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.secondsAfterLastEmail !== 'undefined') {
      toReturn['secondsAfterLastEmail'] = this.secondsAfterLastEmail;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CampaignStepStats {
  static fromProto(proto) {
    let m = new CampaignStepStats();
    m = Object.assign(m, proto);
    if (proto.delivered) {
      m.delivered = parseInt(proto.delivered, 10);
    }
    if (proto.opens) {
      m.opens = parseInt(proto.opens, 10);
    }
    if (proto.bounced) {
      m.bounced = parseInt(proto.bounced, 10);
    }
    if (proto.spam) {
      m.spam = parseInt(proto.spam, 10);
    }
    if (proto.unsubscribed) {
      m.unsubscribed = parseInt(proto.unsubscribed, 10);
    }
    if (proto.dropped) {
      m.dropped = parseInt(proto.dropped, 10);
    }
    if (proto.clicks) {
      m.clicks = parseInt(proto.clicks, 10);
    }
    if (proto.pending) {
      m.pending = parseInt(proto.pending, 10);
    }
    if (proto.created) {
      m.created = parseInt(proto.created, 10);
    }
    if (proto.refreshed) {
      m.refreshed = parseInt(proto.refreshed, 10);
    }
    if (proto.notRequired) {
      m.notRequired = parseInt(proto.notRequired, 10);
    }
    if (proto.sent) {
      m.sent = parseInt(proto.sent, 10);
    }
    if (proto.stopped) {
      m.stopped = parseInt(proto.stopped, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.delivered !== 'undefined') {
      toReturn['delivered'] = this.delivered;
    }
    if (typeof this.opens !== 'undefined') {
      toReturn['opens'] = this.opens;
    }
    if (typeof this.openRate !== 'undefined') {
      toReturn['openRate'] = this.openRate;
    }
    if (typeof this.clickToOpenRate !== 'undefined') {
      toReturn['clickToOpenRate'] = this.clickToOpenRate;
    }
    if (typeof this.bounced !== 'undefined') {
      toReturn['bounced'] = this.bounced;
    }
    if (typeof this.spam !== 'undefined') {
      toReturn['spam'] = this.spam;
    }
    if (typeof this.unsubscribed !== 'undefined') {
      toReturn['unsubscribed'] = this.unsubscribed;
    }
    if (typeof this.dropped !== 'undefined') {
      toReturn['dropped'] = this.dropped;
    }
    if (typeof this.clicks !== 'undefined') {
      toReturn['clicks'] = this.clicks;
    }
    if (typeof this.pending !== 'undefined') {
      toReturn['pending'] = this.pending;
    }
    if (typeof this.created !== 'undefined') {
      toReturn['created'] = this.created;
    }
    if (typeof this.refreshed !== 'undefined') {
      toReturn['refreshed'] = this.refreshed;
    }
    if (typeof this.notRequired !== 'undefined') {
      toReturn['notRequired'] = this.notRequired;
    }
    if (typeof this.sent !== 'undefined') {
      toReturn['sent'] = this.sent;
    }
    if (typeof this.stopped !== 'undefined') {
      toReturn['stopped'] = this.stopped;
    }
    return toReturn;
  }
}
class CampaignTag {
  static fromProto(proto) {
    let m = new CampaignTag();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.colour !== 'undefined') {
      toReturn['colour'] = this.colour;
    }
    return toReturn;
  }
}
class CheckDuplicateCampaignStatusRequest {
  static fromProto(proto) {
    let m = new CheckDuplicateCampaignStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    return toReturn;
  }
}
class CheckDuplicateCampaignStatusResponse {
  static fromProto(proto) {
    let m = new CheckDuplicateCampaignStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(AsyncWorkStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class CheckDuplicateCampaignStepStatusRequest {
  static fromProto(proto) {
    let m = new CheckDuplicateCampaignStepStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    return toReturn;
  }
}
class CheckDuplicateCampaignStepStatusResponse {
  static fromProto(proto) {
    let m = new CheckDuplicateCampaignStepStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(DuplicateCampaignStepStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class Contact {
  static fromProto(proto) {
    let m = new Contact();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(ContactType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ConvertLegacyTemplateRequest {
  static fromProto(proto) {
    let m = new ConvertLegacyTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ConvertLegacyTemplateResponse {
  static fromProto(proto) {
    let m = new ConvertLegacyTemplateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class CreateCampaignRequest {
  static fromProto(proto) {
    let m = new CreateCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.focus) {
      m.focus = enumStringToValue(Focuses, proto.focus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.focus !== 'undefined') {
      toReturn['focus'] = this.focus;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CreateCampaignResponse {
  static fromProto(proto) {
    let m = new CreateCampaignResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class CreateEmailTemplateRequest {
  static fromProto(proto) {
    let m = new CreateEmailTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = EmailTemplateStruct.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class CreateQuotaRequest {
  static fromProto(proto) {
    let m = new CreateQuotaRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.type) {
      m.type = enumStringToValue(CampaignQuotaCategory, proto.type);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    if (proto.quotaStartDate) {
      m.quotaStartDate = new Date(proto.quotaStartDate);
    }
    if (proto.quotaEndDate) {
      m.quotaEndDate = new Date(proto.quotaEndDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    if (typeof this.quotaStartDate !== 'undefined' && this.quotaStartDate !== null) {
      toReturn['quotaStartDate'] = 'toApiJson' in this.quotaStartDate ? this.quotaStartDate.toApiJson() : this.quotaStartDate;
    }
    if (typeof this.quotaEndDate !== 'undefined' && this.quotaEndDate !== null) {
      toReturn['quotaEndDate'] = 'toApiJson' in this.quotaEndDate ? this.quotaEndDate.toApiJson() : this.quotaEndDate;
    }
    return toReturn;
  }
}
class CreateRecipientCampaignStepEventRequest {
  static fromProto(proto) {
    let m = new CreateRecipientCampaignStepEventRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.eventType) {
      m.eventType = enumStringToValue(CampaignStepEventType, proto.eventType);
    }
    if (proto.eventDate) {
      m.eventDate = new Date(proto.eventDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    if (typeof this.recipientCampaignStepId !== 'undefined') {
      toReturn['recipientCampaignStepId'] = this.recipientCampaignStepId;
    }
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.eventDate !== 'undefined' && this.eventDate !== null) {
      toReturn['eventDate'] = 'toApiJson' in this.eventDate ? this.eventDate.toApiJson() : this.eventDate;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.probablyBot !== 'undefined') {
      toReturn['probablyBot'] = this.probablyBot;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.normalizedUrl !== 'undefined') {
      toReturn['normalizedUrl'] = this.normalizedUrl;
    }
    return toReturn;
  }
}
class CreateRecipientRequest {
  static fromProto(proto) {
    let m = new CreateRecipientRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.recipient) {
      m.recipient = RecipientV2.fromProto(proto.recipient);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    return toReturn;
  }
}
class CreateRequest {
  static fromProto(proto) {
    let m = new CreateRequest();
    m = Object.assign(m, proto);
    if (proto.emailBuilderTemplate) {
      m.emailBuilderTemplate = EmailBuilderTemplate.fromProto(proto.emailBuilderTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailBuilderTemplate !== 'undefined' && this.emailBuilderTemplate !== null) {
      toReturn['emailBuilderTemplate'] = 'toApiJson' in this.emailBuilderTemplate ? this.emailBuilderTemplate.toApiJson() : this.emailBuilderTemplate;
    }
    return toReturn;
  }
}
class CreateResponse {
  static fromProto(proto) {
    let m = new CreateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreateTagRequest {
  static fromProto(proto) {
    let m = new CreateTagRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.colour !== 'undefined') {
      toReturn['colour'] = this.colour;
    }
    return toReturn;
  }
}
class CreateTagResponse {
  static fromProto(proto) {
    let m = new CreateTagResponse();
    m = Object.assign(m, proto);
    if (proto.campaignTag) {
      m.campaignTag = CampaignTag.fromProto(proto.campaignTag);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignTag !== 'undefined' && this.campaignTag !== null) {
      toReturn['campaignTag'] = 'toApiJson' in this.campaignTag ? this.campaignTag.toApiJson() : this.campaignTag;
    }
    return toReturn;
  }
}
class DateFilter {
  static fromProto(proto) {
    let m = new DateFilter();
    m = Object.assign(m, proto);
    if (proto.dateLte) {
      m.dateLte = new Date(proto.dateLte);
    }
    if (proto.dateGte) {
      m.dateGte = new Date(proto.dateGte);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateLte !== 'undefined' && this.dateLte !== null) {
      toReturn['dateLte'] = 'toApiJson' in this.dateLte ? this.dateLte.toApiJson() : this.dateLte;
    }
    if (typeof this.dateGte !== 'undefined' && this.dateGte !== null) {
      toReturn['dateGte'] = 'toApiJson' in this.dateGte ? this.dateGte.toApiJson() : this.dateGte;
    }
    return toReturn;
  }
}
class DeactivateProductForSenderRequest {
  static fromProto(proto) {
    let m = new DeactivateProductForSenderRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class DeleteCampaignRequest {
  static fromProto(proto) {
    let m = new DeleteCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class DeleteRequest {
  static fromProto(proto) {
    let m = new DeleteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DeleteTagRequest {
  static fromProto(proto) {
    let m = new DeleteTagRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    return toReturn;
  }
}
class DuplicateAndRecommendCampaignRequest {
  static fromProto(proto) {
    let m = new DuplicateAndRecommendCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.campaignDetails) {
      m.campaignDetails = DuplicateCampaignDetails.fromProto(proto.campaignDetails);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignDetails !== 'undefined' && this.campaignDetails !== null) {
      toReturn['campaignDetails'] = 'toApiJson' in this.campaignDetails ? this.campaignDetails.toApiJson() : this.campaignDetails;
    }
    return toReturn;
  }
}
class DuplicateCampaignDetails {
  static fromProto(proto) {
    let m = new DuplicateCampaignDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class DuplicateCampaignRequest {
  static fromProto(proto) {
    let m = new DuplicateCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.campaignDetails) {
      m.campaignDetails = DuplicateCampaignDetails.fromProto(proto.campaignDetails);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.campaignDetails !== 'undefined' && this.campaignDetails !== null) {
      toReturn['campaignDetails'] = 'toApiJson' in this.campaignDetails ? this.campaignDetails.toApiJson() : this.campaignDetails;
    }
    return toReturn;
  }
}
class DuplicateCampaignRequestV2 {
  static fromProto(proto) {
    let m = new DuplicateCampaignRequestV2();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.campaignDetails) {
      m.campaignDetails = DuplicateCampaignDetails.fromProto(proto.campaignDetails);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.campaignDetails !== 'undefined' && this.campaignDetails !== null) {
      toReturn['campaignDetails'] = 'toApiJson' in this.campaignDetails ? this.campaignDetails.toApiJson() : this.campaignDetails;
    }
    return toReturn;
  }
}
class DuplicateCampaignResponse {
  static fromProto(proto) {
    let m = new DuplicateCampaignResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    return toReturn;
  }
}
class DuplicateCampaignStepRequest {
  static fromProto(proto) {
    let m = new DuplicateCampaignStepRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    return toReturn;
  }
}
class DuplicateCampaignStepResponse {
  static fromProto(proto) {
    let m = new DuplicateCampaignStepResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    return toReturn;
  }
}
class EmailTemplateStruct {
  static fromProto(proto) {
    let m = new EmailTemplateStruct();
    m = Object.assign(m, proto);
    if (proto.campaignFocus) {
      m.campaignFocus = enumStringToValue(Focuses, proto.campaignFocus);
    }
    if (proto.status) {
      m.status = enumStringToValue(TemplateStatus, proto.status);
    }
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.campaignFocus !== 'undefined') {
      toReturn['campaignFocus'] = this.campaignFocus;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.isEditable !== 'undefined') {
      toReturn['isEditable'] = this.isEditable;
    }
    if (typeof this.updatedByUserEmail !== 'undefined') {
      toReturn['updatedByUserEmail'] = this.updatedByUserEmail;
    }
    if (typeof this.createdByUserEmail !== 'undefined') {
      toReturn['createdByUserEmail'] = this.createdByUserEmail;
    }
    if (typeof this.publishedByUserEmail !== 'undefined') {
      toReturn['publishedByUserEmail'] = this.publishedByUserEmail;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.htmlBody !== 'undefined') {
      toReturn['htmlBody'] = this.htmlBody;
    }
    if (typeof this.useFullHtml !== 'undefined') {
      toReturn['useFullHtml'] = this.useFullHtml;
    }
    if (typeof this.fullHtml !== 'undefined') {
      toReturn['fullHtml'] = this.fullHtml;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class ExecuteStepRequest {
  static fromProto(proto) {
    let m = new ExecuteStepRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    if (typeof this.recipientCampaignStepId !== 'undefined') {
      toReturn['recipientCampaignStepId'] = this.recipientCampaignStepId;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    return toReturn;
  }
}
class ExportRecipientLinkClickStatsRequest {
  static fromProto(proto) {
    let m = new ExportRecipientLinkClickStatsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.normalizedUrl !== 'undefined') {
      toReturn['normalizedUrl'] = this.normalizedUrl;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class ExtractLinkTrackingDataForTemplateRequest {
  static fromProto(proto) {
    let m = new ExtractLinkTrackingDataForTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.hydratedTemplateContent !== 'undefined') {
      toReturn['hydratedTemplateContent'] = this.hydratedTemplateContent;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class ExtractLinkTrackingDataForTemplateResponse {
  static fromProto(proto) {
    let m = new ExtractLinkTrackingDataForTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.links) {
      m.links = proto.links.map(LinkTrackingData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.links !== 'undefined' && this.links !== null) {
      toReturn['links'] = 'toApiJson' in this.links ? this.links.toApiJson() : this.links;
    }
    return toReturn;
  }
}
class GetAggregatedCampaignStatsRequest {
  static fromProto(proto) {
    let m = new GetAggregatedCampaignStatsRequest();
    m = Object.assign(m, proto);
    if (proto.focus) {
      m.focus = enumStringToValue(Focuses, proto.focus);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(Statuses, v));
    }
    if (proto.states) {
      m.states = proto.states.map(v => enumStringToValue(CampaignState, v));
    }
    if (proto.dateFilter) {
      m.dateFilter = DateFilter.fromProto(proto.dateFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.focus !== 'undefined') {
      toReturn['focus'] = this.focus;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.states !== 'undefined') {
      toReturn['states'] = this.states;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.dateFilter !== 'undefined' && this.dateFilter !== null) {
      toReturn['dateFilter'] = 'toApiJson' in this.dateFilter ? this.dateFilter.toApiJson() : this.dateFilter;
    }
    return toReturn;
  }
}
class GetAggregatedCampaignStatsResponse {
  static fromProto(proto) {
    let m = new GetAggregatedCampaignStatsResponse();
    m = Object.assign(m, proto);
    if (proto.totalAccounts) {
      m.totalAccounts = parseInt(proto.totalAccounts, 10);
    }
    if (proto.totalActiveCampaigns) {
      m.totalActiveCampaigns = parseInt(proto.totalActiveCampaigns, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totalAccounts !== 'undefined') {
      toReturn['totalAccounts'] = this.totalAccounts;
    }
    if (typeof this.averageClickThroughRate !== 'undefined') {
      toReturn['averageClickThroughRate'] = this.averageClickThroughRate;
    }
    if (typeof this.averageOpenRate !== 'undefined') {
      toReturn['averageOpenRate'] = this.averageOpenRate;
    }
    if (typeof this.totalActiveCampaigns !== 'undefined') {
      toReturn['totalActiveCampaigns'] = this.totalActiveCampaigns;
    }
    return toReturn;
  }
}
class GetAvailableStepTypesForSenderRequest {
  static fromProto(proto) {
    let m = new GetAvailableStepTypesForSenderRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    return toReturn;
  }
}
class GetAvailableStepTypesForSenderResponse {
  static fromProto(proto) {
    let m = new GetAvailableStepTypesForSenderResponse();
    m = Object.assign(m, proto);
    if (proto.availableStepTypes) {
      m.availableStepTypes = proto.availableStepTypes.map(v => enumStringToValue(Feature, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.availableStepTypes !== 'undefined') {
      toReturn['availableStepTypes'] = this.availableStepTypes;
    }
    return toReturn;
  }
}
class GetCampaignDetailsStatsRequest {
  static fromProto(proto) {
    let m = new GetCampaignDetailsStatsRequest();
    m = Object.assign(m, proto);
    if (proto.dateFilter) {
      m.dateFilter = DateFilter.fromProto(proto.dateFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.dateFilter !== 'undefined' && this.dateFilter !== null) {
      toReturn['dateFilter'] = 'toApiJson' in this.dateFilter ? this.dateFilter.toApiJson() : this.dateFilter;
    }
    return toReturn;
  }
}
class GetCampaignDetailsStatsResponse {
  static fromProto(proto) {
    let m = new GetCampaignDetailsStatsResponse();
    m = Object.assign(m, proto);
    if (proto.stats) {
      m.stats = CampaignDetailStats.fromProto(proto.stats);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    return toReturn;
  }
}
class GetCampaignQuotaRequest {
  static fromProto(proto) {
    let m = new GetCampaignQuotaRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.type) {
      m.type = enumStringToValue(CampaignQuotaCategory, proto.type);
    }
    if (proto.datePeriod) {
      m.datePeriod = enumStringToValue(Period, proto.datePeriod);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.datePeriod !== 'undefined') {
      toReturn['datePeriod'] = this.datePeriod;
    }
    return toReturn;
  }
}
class GetCampaignQuotaResponse {
  static fromProto(proto) {
    let m = new GetCampaignQuotaResponse();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    if (proto.quotaStartDate) {
      m.quotaStartDate = new Date(proto.quotaStartDate);
    }
    if (proto.quotaEndDate) {
      m.quotaEndDate = new Date(proto.quotaEndDate);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    if (typeof this.quotaStartDate !== 'undefined' && this.quotaStartDate !== null) {
      toReturn['quotaStartDate'] = 'toApiJson' in this.quotaStartDate ? this.quotaStartDate.toApiJson() : this.quotaStartDate;
    }
    if (typeof this.quotaEndDate !== 'undefined' && this.quotaEndDate !== null) {
      toReturn['quotaEndDate'] = 'toApiJson' in this.quotaEndDate ? this.quotaEndDate.toApiJson() : this.quotaEndDate;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class GetCampaignRequest {
  static fromProto(proto) {
    let m = new GetCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class GetCampaignResponse {
  static fromProto(proto) {
    let m = new GetCampaignResponse();
    m = Object.assign(m, proto);
    if (proto.campaign) {
      m.campaign = GetterCampaignData.fromProto(proto.campaign);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaign !== 'undefined' && this.campaign !== null) {
      toReturn['campaign'] = 'toApiJson' in this.campaign ? this.campaign.toApiJson() : this.campaign;
    }
    return toReturn;
  }
}
class GetCampaignStepContentRequest {
  static fromProto(proto) {
    let m = new GetCampaignStepContentRequest();
    m = Object.assign(m, proto);
    if (proto.stepData) {
      m.stepData = Object.keys(proto.stepData).reduce((obj, k) => {
        obj[k] = proto.stepData[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.stepData !== 'undefined' && this.stepData !== null) {
      toReturn['stepData'] = 'toApiJson' in this.stepData ? this.stepData.toApiJson() : this.stepData;
    }
    return toReturn;
  }
}
class GetCampaignStepContentResponse {
  static fromProto(proto) {
    let m = new GetCampaignStepContentResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.html !== 'undefined') {
      toReturn['html'] = this.html;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    return toReturn;
  }
}
class GetCampaignStepStatsRequest {
  static fromProto(proto) {
    let m = new GetCampaignStepStatsRequest();
    m = Object.assign(m, proto);
    if (proto.dateFilter) {
      m.dateFilter = DateFilter.fromProto(proto.dateFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.dateFilter !== 'undefined' && this.dateFilter !== null) {
      toReturn['dateFilter'] = 'toApiJson' in this.dateFilter ? this.dateFilter.toApiJson() : this.dateFilter;
    }
    return toReturn;
  }
}
class GetCampaignStepStatsResponse {
  static fromProto(proto) {
    let m = new GetCampaignStepStatsResponse();
    m = Object.assign(m, proto);
    if (proto.stepStats) {
      m.stepStats = proto.stepStats.map(CampaignStepStats.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stepStats !== 'undefined' && this.stepStats !== null) {
      toReturn['stepStats'] = 'toApiJson' in this.stepStats ? this.stepStats.toApiJson() : this.stepStats;
    }
    return toReturn;
  }
}
class GetConfigRequest {
  static fromProto(proto) {
    let m = new GetConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class GetConfigResponse {
  static fromProto(proto) {
    let m = new GetConfigResponse();
    m = Object.assign(m, proto);
    if (proto.rateLimit) {
      m.rateLimit = parseInt(proto.rateLimit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.timezone !== 'undefined') {
      toReturn['timezone'] = this.timezone;
    }
    if (typeof this.days !== 'undefined') {
      toReturn['days'] = this.days;
    }
    if (typeof this.rateLimited !== 'undefined') {
      toReturn['rateLimited'] = this.rateLimited;
    }
    if (typeof this.rateLimit !== 'undefined') {
      toReturn['rateLimit'] = this.rateLimit;
    }
    return toReturn;
  }
}
class GetEmailTemplateRequest {
  static fromProto(proto) {
    let m = new GetEmailTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class GetEmailTemplateResponse {
  static fromProto(proto) {
    let m = new GetEmailTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = EmailTemplateStruct.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class GetEmailTemplatesRequest {
  static fromProto(proto) {
    let m = new GetEmailTemplatesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateIds !== 'undefined') {
      toReturn['templateIds'] = this.templateIds;
    }
    return toReturn;
  }
}
class GetEmailTemplatesResponse {
  static fromProto(proto) {
    let m = new GetEmailTemplatesResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(EmailTemplateStruct.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    return toReturn;
  }
}
class GetLinkStatsRequest {
  static fromProto(proto) {
    let m = new GetLinkStatsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    return toReturn;
  }
}
class GetLinkStatsResponse {
  static fromProto(proto) {
    let m = new GetLinkStatsResponse();
    m = Object.assign(m, proto);
    if (proto.stats) {
      m.stats = proto.stats.map(LinkStats.fromProto);
    }
    if (proto.totalClicksOnCampaignStep) {
      m.totalClicksOnCampaignStep = parseInt(proto.totalClicksOnCampaignStep, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    if (typeof this.totalClicksOnCampaignStep !== 'undefined') {
      toReturn['totalClicksOnCampaignStep'] = this.totalClicksOnCampaignStep;
    }
    return toReturn;
  }
}
class GetMultiCampaignsRequest {
  static fromProto(proto) {
    let m = new GetMultiCampaignsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignIds !== 'undefined') {
      toReturn['campaignIds'] = this.campaignIds;
    }
    return toReturn;
  }
}
class GetMultiCampaignsResponse {
  static fromProto(proto) {
    let m = new GetMultiCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(GetterCampaignData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    return toReturn;
  }
}
class GetRecipientCampaignRequest {
  static fromProto(proto) {
    let m = new GetRecipientCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    return toReturn;
  }
}
class GetRecipientCampaignResponse {
  static fromProto(proto) {
    let m = new GetRecipientCampaignResponse();
    m = Object.assign(m, proto);
    if (proto.recipientCampaign) {
      m.recipientCampaign = RecipientCampaignStruct.fromProto(proto.recipientCampaign);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaign !== 'undefined' && this.recipientCampaign !== null) {
      toReturn['recipientCampaign'] = 'toApiJson' in this.recipientCampaign ? this.recipientCampaign.toApiJson() : this.recipientCampaign;
    }
    return toReturn;
  }
}
class GetRecipientLinkClickStatsRequest {
  static fromProto(proto) {
    let m = new GetRecipientLinkClickStatsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = GetRecipientLinkClickStatsRequestPagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.normalizedUrl !== 'undefined') {
      toReturn['normalizedUrl'] = this.normalizedUrl;
    }
    return toReturn;
  }
}
class GetRecipientLinkClickStatsResponse {
  static fromProto(proto) {
    let m = new GetRecipientLinkClickStatsResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    if (proto.data) {
      m.data = proto.data.map(RecipientClickStats.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    return toReturn;
  }
}
class GetRecipientRequest {
  static fromProto(proto) {
    let m = new GetRecipientRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    return toReturn;
  }
}
class GetRecipientResponse {
  static fromProto(proto) {
    let m = new GetRecipientResponse();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.recipient) {
      m.recipient = RecipientV2.fromProto(proto.recipient);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    return toReturn;
  }
}
class GetRequest {
  static fromProto(proto) {
    let m = new GetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetResponse {
  static fromProto(proto) {
    let m = new GetResponse();
    m = Object.assign(m, proto);
    if (proto.emailBuilderTemplate) {
      m.emailBuilderTemplate = EmailBuilderTemplate.fromProto(proto.emailBuilderTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailBuilderTemplate !== 'undefined' && this.emailBuilderTemplate !== null) {
      toReturn['emailBuilderTemplate'] = 'toApiJson' in this.emailBuilderTemplate ? this.emailBuilderTemplate.toApiJson() : this.emailBuilderTemplate;
    }
    return toReturn;
  }
}
class GetterCampaignData {
  static fromProto(proto) {
    let m = new GetterCampaignData();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.focus) {
      m.focus = enumStringToValue(Focuses, proto.focus);
    }
    if (proto.campaignSchedule) {
      m.campaignSchedule = proto.campaignSchedule.map(CampaignStepInterface.fromProto);
    }
    if (proto.campaignScheduleVersion) {
      m.campaignScheduleVersion = parseInt(proto.campaignScheduleVersion, 10);
    }
    if (proto.eventsCount) {
      m.eventsCount = parseInt(proto.eventsCount, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue(Statuses, proto.status);
    }
    if (proto.published) {
      m.published = new Date(proto.published);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.focus !== 'undefined') {
      toReturn['focus'] = this.focus;
    }
    if (typeof this.campaignSchedule !== 'undefined' && this.campaignSchedule !== null) {
      toReturn['campaignSchedule'] = 'toApiJson' in this.campaignSchedule ? this.campaignSchedule.toApiJson() : this.campaignSchedule;
    }
    if (typeof this.campaignScheduleVersion !== 'undefined') {
      toReturn['campaignScheduleVersion'] = this.campaignScheduleVersion;
    }
    if (typeof this.eventsCount !== 'undefined') {
      toReturn['eventsCount'] = this.eventsCount;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.isEnabled !== 'undefined') {
      toReturn['isEnabled'] = this.isEnabled;
    }
    if (typeof this.isEditable !== 'undefined') {
      toReturn['isEditable'] = this.isEditable;
    }
    if (typeof this.hiddenForPartners !== 'undefined') {
      toReturn['hiddenForPartners'] = this.hiddenForPartners;
    }
    if (typeof this.isPremade !== 'undefined') {
      toReturn['isPremade'] = this.isPremade;
    }
    if (typeof this.parentCampaignId !== 'undefined') {
      toReturn['parentCampaignId'] = this.parentCampaignId;
    }
    if (typeof this.rootCampaignId !== 'undefined') {
      toReturn['rootCampaignId'] = this.rootCampaignId;
    }
    if (typeof this.createdUser !== 'undefined') {
      toReturn['createdUser'] = this.createdUser;
    }
    if (typeof this.updatedUser !== 'undefined') {
      toReturn['updatedUser'] = this.updatedUser;
    }
    if (typeof this.publishedUser !== 'undefined') {
      toReturn['publishedUser'] = this.publishedUser;
    }
    if (typeof this.emailCategoryId !== 'undefined') {
      toReturn['emailCategoryId'] = this.emailCategoryId;
    }
    if (typeof this.published !== 'undefined' && this.published !== null) {
      toReturn['published'] = 'toApiJson' in this.published ? this.published.toApiJson() : this.published;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class IsFeatureActiveForSenderRequest {
  static fromProto(proto) {
    let m = new IsFeatureActiveForSenderRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.featureId) {
      m.featureId = enumStringToValue(Feature, proto.featureId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.featureId !== 'undefined') {
      toReturn['featureId'] = this.featureId;
    }
    return toReturn;
  }
}
class IsFeatureActiveForSenderResponse {
  static fromProto(proto) {
    let m = new IsFeatureActiveForSenderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    return toReturn;
  }
}
class IsProductActiveForSenderRequest {
  static fromProto(proto) {
    let m = new IsProductActiveForSenderRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class IsProductActiveForSenderResponse {
  static fromProto(proto) {
    let m = new IsProductActiveForSenderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    return toReturn;
  }
}
class LegacyAddAccountGroupToCampaignRequest {
  static fromProto(proto) {
    let m = new LegacyAddAccountGroupToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.scheduledDate) {
      m.scheduledDate = new Date(proto.scheduledDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.scheduledDate !== 'undefined' && this.scheduledDate !== null) {
      toReturn['scheduledDate'] = 'toApiJson' in this.scheduledDate ? this.scheduledDate.toApiJson() : this.scheduledDate;
    }
    return toReturn;
  }
}
class LegacyGetRecipientCampaignsByAgidRequest {
  static fromProto(proto) {
    let m = new LegacyGetRecipientCampaignsByAgidRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class LegacyGetRecipientCampaignsByAgidResponse {
  static fromProto(proto) {
    let m = new LegacyGetRecipientCampaignsByAgidResponse();
    m = Object.assign(m, proto);
    if (proto.recipientCampaignPairs) {
      m.recipientCampaignPairs = proto.recipientCampaignPairs.map(RecipientCampaignPair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaignPairs !== 'undefined' && this.recipientCampaignPairs !== null) {
      toReturn['recipientCampaignPairs'] = 'toApiJson' in this.recipientCampaignPairs ? this.recipientCampaignPairs.toApiJson() : this.recipientCampaignPairs;
    }
    return toReturn;
  }
}
class LegacyPauseAccountGroupOnCampaignRequest {
  static fromProto(proto) {
    let m = new LegacyPauseAccountGroupOnCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class LegacyRateLimitedAddToCampaignRequest {
  static fromProto(proto) {
    let m = new LegacyRateLimitedAddToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.scheduledDate) {
      m.scheduledDate = new Date(proto.scheduledDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.scheduledDate !== 'undefined' && this.scheduledDate !== null) {
      toReturn['scheduledDate'] = 'toApiJson' in this.scheduledDate ? this.scheduledDate.toApiJson() : this.scheduledDate;
    }
    if (typeof this.fromEmail !== 'undefined') {
      toReturn['fromEmail'] = this.fromEmail;
    }
    if (typeof this.fromName !== 'undefined') {
      toReturn['fromName'] = this.fromName;
    }
    if (typeof this.fromId !== 'undefined') {
      toReturn['fromId'] = this.fromId;
    }
    return toReturn;
  }
}
class LegacyRateLimitedAddToCampaignResponse {
  static fromProto(proto) {
    let m = new LegacyRateLimitedAddToCampaignResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    return toReturn;
  }
}
class LegacyUpdateRecipientCampaignStatusRequest {
  static fromProto(proto) {
    let m = new LegacyUpdateRecipientCampaignStatusRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(RecipientCampaignStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class LinkStats {
  static fromProto(proto) {
    let m = new LinkStats();
    m = Object.assign(m, proto);
    if (proto.totalClicks) {
      m.totalClicks = parseInt(proto.totalClicks, 10);
    }
    if (proto.uniqueClicks) {
      m.uniqueClicks = parseInt(proto.uniqueClicks, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.totalClicks !== 'undefined') {
      toReturn['totalClicks'] = this.totalClicks;
    }
    if (typeof this.uniqueClicks !== 'undefined') {
      toReturn['uniqueClicks'] = this.uniqueClicks;
    }
    if (typeof this.clickRate !== 'undefined') {
      toReturn['clickRate'] = this.clickRate;
    }
    return toReturn;
  }
}
class LinkTrackingData {
  static fromProto(proto) {
    let m = new LinkTrackingData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.normalizedUrl !== 'undefined') {
      toReturn['normalizedUrl'] = this.normalizedUrl;
    }
    if (typeof this.hydratedUrl !== 'undefined') {
      toReturn['hydratedUrl'] = this.hydratedUrl;
    }
    return toReturn;
  }
}
class ListCampaignStatsForSenderRequest {
  static fromProto(proto) {
    let m = new ListCampaignStatsForSenderRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.focus) {
      m.focus = enumStringToValue(Focuses, proto.focus);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(Statuses, v));
    }
    if (proto.states) {
      m.states = proto.states.map(v => enumStringToValue(CampaignState, v));
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.deletedTagsPolicy) {
      m.deletedTagsPolicy = enumStringToValue(DeletedTagsPolicy, proto.deletedTagsPolicy);
    }
    if (proto.sortOptions) {
      m.sortOptions = SortOptions.fromProto(proto.sortOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.focus !== 'undefined') {
      toReturn['focus'] = this.focus;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.states !== 'undefined') {
      toReturn['states'] = this.states;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.deletedTagsPolicy !== 'undefined') {
      toReturn['deletedTagsPolicy'] = this.deletedTagsPolicy;
    }
    if (typeof this.tagIds !== 'undefined') {
      toReturn['tagIds'] = this.tagIds;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    return toReturn;
  }
}
class ListCampaignStatsForSenderResponse {
  static fromProto(proto) {
    let m = new ListCampaignStatsForSenderResponse();
    m = Object.assign(m, proto);
    if (proto.stats) {
      m.stats = proto.stats.map(ListCampaignStatsStruct.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListCampaignStatsRequest {
  static fromProto(proto) {
    let m = new ListCampaignStatsRequest();
    m = Object.assign(m, proto);
    if (proto.focus) {
      m.focus = enumStringToValue(Focuses, proto.focus);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(Statuses, v));
    }
    if (proto.states) {
      m.states = proto.states.map(v => enumStringToValue(CampaignState, v));
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.deletedTagsPolicy) {
      m.deletedTagsPolicy = enumStringToValue(DeletedTagsPolicy, proto.deletedTagsPolicy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.focus !== 'undefined') {
      toReturn['focus'] = this.focus;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.states !== 'undefined') {
      toReturn['states'] = this.states;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.deletedTagsPolicy !== 'undefined') {
      toReturn['deletedTagsPolicy'] = this.deletedTagsPolicy;
    }
    if (typeof this.tagIds !== 'undefined') {
      toReturn['tagIds'] = this.tagIds;
    }
    return toReturn;
  }
}
class ListCampaignStatsResponse {
  static fromProto(proto) {
    let m = new ListCampaignStatsResponse();
    m = Object.assign(m, proto);
    if (proto.stats) {
      m.stats = proto.stats.map(ListCampaignStatsStruct.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListCampaignStatsStruct {
  static fromProto(proto) {
    let m = new ListCampaignStatsStruct();
    m = Object.assign(m, proto);
    if (proto.totalAccounts) {
      m.totalAccounts = parseInt(proto.totalAccounts, 10);
    }
    if (proto.activeAccounts) {
      m.activeAccounts = parseInt(proto.activeAccounts, 10);
    }
    if (proto.emailsDelivered) {
      m.emailsDelivered = parseInt(proto.emailsDelivered, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue(Statuses, proto.status);
    }
    if (proto.state) {
      m.state = enumStringToValue(CampaignState, proto.state);
    }
    if (proto.eventsCount) {
      m.eventsCount = parseInt(proto.eventsCount, 10);
    }
    if (proto.tags) {
      m.tags = proto.tags.map(ListCampaignTagDetails.fromProto);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.totalAccounts !== 'undefined') {
      toReturn['totalAccounts'] = this.totalAccounts;
    }
    if (typeof this.activeAccounts !== 'undefined') {
      toReturn['activeAccounts'] = this.activeAccounts;
    }
    if (typeof this.emailsDelivered !== 'undefined') {
      toReturn['emailsDelivered'] = this.emailsDelivered;
    }
    if (typeof this.clickThroughRate !== 'undefined') {
      toReturn['clickThroughRate'] = this.clickThroughRate;
    }
    if (typeof this.openRate !== 'undefined') {
      toReturn['openRate'] = this.openRate;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.automations !== 'undefined') {
      toReturn['automations'] = this.automations;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.eventsCount !== 'undefined') {
      toReturn['eventsCount'] = this.eventsCount;
    }
    if (typeof this.isEditable !== 'undefined') {
      toReturn['isEditable'] = this.isEditable;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class ListCampaignTagDetails {
  static fromProto(proto) {
    let m = new ListCampaignTagDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.color !== 'undefined') {
      toReturn['color'] = this.color;
    }
    return toReturn;
  }
}
class ListCampaignsRequest {
  static fromProto(proto) {
    let m = new ListCampaignsRequest();
    m = Object.assign(m, proto);
    if (proto.focuses) {
      m.focuses = proto.focuses.map(v => enumStringToValue(Focuses, v));
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(Statuses, v));
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.focuses !== 'undefined') {
      toReturn['focuses'] = this.focuses;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class ListCampaignsResponse {
  static fromProto(proto) {
    let m = new ListCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(GetterCampaignData.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListCampaignsV2Request {
  static fromProto(proto) {
    let m = new ListCampaignsV2Request();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(Statuses, v));
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.sortOptions) {
      m.sortOptions = SortOptions.fromProto(proto.sortOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    return toReturn;
  }
}
class ListCampaignsV2Response {
  static fromProto(proto) {
    let m = new ListCampaignsV2Response();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(GetterCampaignData.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListLinksInTemplateRequest {
  static fromProto(proto) {
    let m = new ListLinksInTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class ListLinksInTemplateResponse {
  static fromProto(proto) {
    let m = new ListLinksInTemplateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.links !== 'undefined') {
      toReturn['links'] = this.links;
    }
    return toReturn;
  }
}
class ListRecipientCampaignsRequest {
  static fromProto(proto) {
    let m = new ListRecipientCampaignsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class ListRecipientCampaignsResponse {
  static fromProto(proto) {
    let m = new ListRecipientCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.recipientCampaign) {
      m.recipientCampaign = proto.recipientCampaign.map(RecipientCampaignStruct.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaign !== 'undefined' && this.recipientCampaign !== null) {
      toReturn['recipientCampaign'] = 'toApiJson' in this.recipientCampaign ? this.recipientCampaign.toApiJson() : this.recipientCampaign;
    }
    return toReturn;
  }
}
class ListRecipientsRequest {
  static fromProto(proto) {
    let m = new ListRecipientsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListRecipientsResponse {
  static fromProto(proto) {
    let m = new ListRecipientsResponse();
    m = Object.assign(m, proto);
    if (proto.recipients) {
      m.recipients = proto.recipients.map(RecipientV2.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipients !== 'undefined' && this.recipients !== null) {
      toReturn['recipients'] = 'toApiJson' in this.recipients ? this.recipients.toApiJson() : this.recipients;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListRecommendedCampaignsRequest {
  static fromProto(proto) {
    let m = new ListRecommendedCampaignsRequest();
    m = Object.assign(m, proto);
    if (proto.focuses) {
      m.focuses = proto.focuses.map(v => enumStringToValue(Focuses, v));
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(Statuses, v));
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.focuses !== 'undefined') {
      toReturn['focuses'] = this.focuses;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListTagsForCampaignRequest {
  static fromProto(proto) {
    let m = new ListTagsForCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListTagsForCampaignResponse {
  static fromProto(proto) {
    let m = new ListTagsForCampaignResponse();
    m = Object.assign(m, proto);
    if (proto.campaignTags) {
      m.campaignTags = proto.campaignTags.map(CampaignTag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignTags !== 'undefined' && this.campaignTags !== null) {
      toReturn['campaignTags'] = 'toApiJson' in this.campaignTags ? this.campaignTags.toApiJson() : this.campaignTags;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListTagsForSenderRequest {
  static fromProto(proto) {
    let m = new ListTagsForSenderRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListTagsForSenderResponse {
  static fromProto(proto) {
    let m = new ListTagsForSenderResponse();
    m = Object.assign(m, proto);
    if (proto.campaignTags) {
      m.campaignTags = proto.campaignTags.map(CampaignTag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignTags !== 'undefined' && this.campaignTags !== null) {
      toReturn['campaignTags'] = 'toApiJson' in this.campaignTags ? this.campaignTags.toApiJson() : this.campaignTags;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class LookupRecipientCampaignRequest {
  static fromProto(proto) {
    let m = new LookupRecipientCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.recipient) {
      m.recipient = RecipientV2.fromProto(proto.recipient);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class LookupRecipientCampaignResponse {
  static fromProto(proto) {
    let m = new LookupRecipientCampaignResponse();
    m = Object.assign(m, proto);
    if (proto.recipientCampaign) {
      m.recipientCampaign = RecipientCampaignStruct.fromProto(proto.recipientCampaign);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaign !== 'undefined' && this.recipientCampaign !== null) {
      toReturn['recipientCampaign'] = 'toApiJson' in this.recipientCampaign ? this.recipientCampaign.toApiJson() : this.recipientCampaign;
    }
    return toReturn;
  }
}
class LookupRecipientCampaignsRequest {
  static fromProto(proto) {
    let m = new LookupRecipientCampaignsRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.recipients) {
      m.recipients = proto.recipients.map(RecipientV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipients !== 'undefined' && this.recipients !== null) {
      toReturn['recipients'] = 'toApiJson' in this.recipients ? this.recipients.toApiJson() : this.recipients;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class LookupRecipientCampaignsResponse {
  static fromProto(proto) {
    let m = new LookupRecipientCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.recipientCampaigns) {
      m.recipientCampaigns = proto.recipientCampaigns.map(RecipientCampaignStruct.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaigns !== 'undefined' && this.recipientCampaigns !== null) {
      toReturn['recipientCampaigns'] = 'toApiJson' in this.recipientCampaigns ? this.recipientCampaigns.toApiJson() : this.recipientCampaigns;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class GetRecipientLinkClickStatsRequestPagedRequestOptions {
  static fromProto(proto) {
    let m = new GetRecipientLinkClickStatsRequestPagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class PauseCampaignRequest {
  static fromProto(proto) {
    let m = new PauseCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class PauseRecipientCampaignRequest {
  static fromProto(proto) {
    let m = new PauseRecipientCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    return toReturn;
  }
}
class PreviewEmailTemplateRequest {
  static fromProto(proto) {
    let m = new PreviewEmailTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    return toReturn;
  }
}
class PreviewEmailTemplateResponse {
  static fromProto(proto) {
    let m = new PreviewEmailTemplateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateHtml !== 'undefined') {
      toReturn['templateHtml'] = this.templateHtml;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class RecipientClickStatsRecipient {
  static fromProto(proto) {
    let m = new RecipientClickStatsRecipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    return toReturn;
  }
}
class RecipientCampaignPair {
  static fromProto(proto) {
    let m = new RecipientCampaignPair();
    m = Object.assign(m, proto);
    if (proto.recipientCampaign) {
      m.recipientCampaign = RecipientCampaignStruct.fromProto(proto.recipientCampaign);
    }
    if (proto.recipient) {
      m.recipient = CampaignRecipient.fromProto(proto.recipient);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaign !== 'undefined' && this.recipientCampaign !== null) {
      toReturn['recipientCampaign'] = 'toApiJson' in this.recipientCampaign ? this.recipientCampaign.toApiJson() : this.recipientCampaign;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    return toReturn;
  }
}
class RecipientCampaignStepEventStruct {
  static fromProto(proto) {
    let m = new RecipientCampaignStepEventStruct();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.eventType) {
      m.eventType = enumStringToValue(CampaignStepEventType, proto.eventType);
    }
    if (proto.eventDate) {
      m.eventDate = new Date(proto.eventDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    if (typeof this.recipientCampaignStepId !== 'undefined') {
      toReturn['recipientCampaignStepId'] = this.recipientCampaignStepId;
    }
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.eventDate !== 'undefined' && this.eventDate !== null) {
      toReturn['eventDate'] = 'toApiJson' in this.eventDate ? this.eventDate.toApiJson() : this.eventDate;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.probablyBot !== 'undefined') {
      toReturn['probablyBot'] = this.probablyBot;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.normalizedUrl !== 'undefined') {
      toReturn['normalizedUrl'] = this.normalizedUrl;
    }
    return toReturn;
  }
}
class RecipientCampaignStruct {
  static fromProto(proto) {
    let m = new RecipientCampaignStruct();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue(CampaignScheduleStatus, proto.status);
    }
    if (proto.schedule) {
      m.schedule = proto.schedule.map(ScheduledCampaignStepInterface.fromProto);
    }
    if (proto.scheduleStep) {
      m.scheduleStep = parseInt(proto.scheduleStep, 10);
    }
    if (proto.pausedDateTime) {
      m.pausedDateTime = new Date(proto.pausedDateTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.fromId !== 'undefined') {
      toReturn['fromId'] = this.fromId;
    }
    if (typeof this.fromEmail !== 'undefined') {
      toReturn['fromEmail'] = this.fromEmail;
    }
    if (typeof this.fromName !== 'undefined') {
      toReturn['fromName'] = this.fromName;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    if (typeof this.isCompleted !== 'undefined') {
      toReturn['isCompleted'] = this.isCompleted;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.schedule !== 'undefined' && this.schedule !== null) {
      toReturn['schedule'] = 'toApiJson' in this.schedule ? this.schedule.toApiJson() : this.schedule;
    }
    if (typeof this.scheduleStep !== 'undefined') {
      toReturn['scheduleStep'] = this.scheduleStep;
    }
    if (typeof this.errorMessage !== 'undefined') {
      toReturn['errorMessage'] = this.errorMessage;
    }
    if (typeof this.pausedDateTime !== 'undefined' && this.pausedDateTime !== null) {
      toReturn['pausedDateTime'] = 'toApiJson' in this.pausedDateTime ? this.pausedDateTime.toApiJson() : this.pausedDateTime;
    }
    return toReturn;
  }
}
class RecipientClickStats {
  static fromProto(proto) {
    let m = new RecipientClickStats();
    m = Object.assign(m, proto);
    if (proto.recipient) {
      m.recipient = RecipientClickStatsRecipient.fromProto(proto.recipient);
    }
    if (proto.account) {
      m.account = RecipientClickStatsAccount.fromProto(proto.account);
    }
    if (proto.recentDate) {
      m.recentDate = new Date(proto.recentDate);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    if (typeof this.account !== 'undefined' && this.account !== null) {
      toReturn['account'] = 'toApiJson' in this.account ? this.account.toApiJson() : this.account;
    }
    if (typeof this.recentDate !== 'undefined' && this.recentDate !== null) {
      toReturn['recentDate'] = 'toApiJson' in this.recentDate ? this.recentDate.toApiJson() : this.recentDate;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class RecipientCriteria {
  static fromProto(proto) {
    let m = new RecipientCriteria();
    m = Object.assign(m, proto);
    if (proto.filterGroupV2) {
      m.filterGroupV2 = FilterGroup.fromProto(proto.filterGroupV2);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.filterGroupV2 !== 'undefined' && this.filterGroupV2 !== null) {
      toReturn['filterGroupV2'] = 'toApiJson' in this.filterGroupV2 ? this.filterGroupV2.toApiJson() : this.filterGroupV2;
    }
    return toReturn;
  }
}
class RecipientV2 {
  static fromProto(proto) {
    let m = new RecipientV2();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(RecipientType, proto.type);
    }
    if (proto.contact) {
      m.contact = Contact.fromProto(proto.contact);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.contact !== 'undefined' && this.contact !== null) {
      toReturn['contact'] = 'toApiJson' in this.contact ? this.contact.toApiJson() : this.contact;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class RemoveTagFromCampaignRequest {
  static fromProto(proto) {
    let m = new RemoveTagFromCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    return toReturn;
  }
}
class RenderRequest {
  static fromProto(proto) {
    let m = new RenderRequest();
    m = Object.assign(m, proto);
    if (proto.emailBuilderTemplate) {
      m.emailBuilderTemplate = EmailBuilderTemplate.fromProto(proto.emailBuilderTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailBuilderTemplate !== 'undefined' && this.emailBuilderTemplate !== null) {
      toReturn['emailBuilderTemplate'] = 'toApiJson' in this.emailBuilderTemplate ? this.emailBuilderTemplate.toApiJson() : this.emailBuilderTemplate;
    }
    return toReturn;
  }
}
class RenderResponse {
  static fromProto(proto) {
    let m = new RenderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class ResumeRecipientCampaignRequest {
  static fromProto(proto) {
    let m = new ResumeRecipientCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    return toReturn;
  }
}
class ScheduledCampaignStepInterface {
  static fromProto(proto) {
    let m = new ScheduledCampaignStepInterface();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.campaignStepType) {
      m.campaignStepType = enumStringToValue(CampaignStepType, proto.campaignStepType);
    }
    if (proto.scheduledDate) {
      m.scheduledDate = new Date(proto.scheduledDate);
    }
    if (proto.dateSent) {
      m.dateSent = new Date(proto.dateSent);
    }
    if (proto.secondsAfterLastEmail) {
      m.secondsAfterLastEmail = parseInt(proto.secondsAfterLastEmail, 10);
    }
    if (proto.sendStatus) {
      m.sendStatus = enumStringToValue(CampaignStepSendStatusType, proto.sendStatus);
    }
    if (proto.events) {
      m.events = proto.events.map(CampaignStepEvent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    if (typeof this.stepId !== 'undefined') {
      toReturn['stepId'] = this.stepId;
    }
    if (typeof this.campaignStepType !== 'undefined') {
      toReturn['campaignStepType'] = this.campaignStepType;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.scheduledDate !== 'undefined' && this.scheduledDate !== null) {
      toReturn['scheduledDate'] = 'toApiJson' in this.scheduledDate ? this.scheduledDate.toApiJson() : this.scheduledDate;
    }
    if (typeof this.dateSent !== 'undefined' && this.dateSent !== null) {
      toReturn['dateSent'] = 'toApiJson' in this.dateSent ? this.dateSent.toApiJson() : this.dateSent;
    }
    if (typeof this.secondsAfterLastEmail !== 'undefined') {
      toReturn['secondsAfterLastEmail'] = this.secondsAfterLastEmail;
    }
    if (typeof this.sendStatus !== 'undefined') {
      toReturn['sendStatus'] = this.sendStatus;
    }
    if (typeof this.completed !== 'undefined') {
      toReturn['completed'] = this.completed;
    }
    if (typeof this.events !== 'undefined' && this.events !== null) {
      toReturn['events'] = 'toApiJson' in this.events ? this.events.toApiJson() : this.events;
    }
    return toReturn;
  }
}
class SendCampaignStepTestEmailRequest {
  static fromProto(proto) {
    let m = new SendCampaignStepTestEmailRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.stepData) {
      m.stepData = Object.keys(proto.stepData).reduce((obj, k) => {
        obj[k] = proto.stepData[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.sendToUserId !== 'undefined') {
      toReturn['sendToUserId'] = this.sendToUserId;
    }
    if (typeof this.stepData !== 'undefined' && this.stepData !== null) {
      toReturn['stepData'] = 'toApiJson' in this.stepData ? this.stepData.toApiJson() : this.stepData;
    }
    return toReturn;
  }
}
class SendCampaignStepTestEmailResponse {
  static fromProto(proto) {
    let m = new SendCampaignStepTestEmailResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    return toReturn;
  }
}
class SendPreviewEmailRequest {
  static fromProto(proto) {
    let m = new SendPreviewEmailRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.htmlContent !== 'undefined') {
      toReturn['htmlContent'] = this.htmlContent;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.recipientUserId !== 'undefined') {
      toReturn['recipientUserId'] = this.recipientUserId;
    }
    return toReturn;
  }
}
class SendRecipientCampaignStepEmailRequest {
  static fromProto(proto) {
    let m = new SendRecipientCampaignStepEmailRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ignoreCampaignState !== 'undefined') {
      toReturn['ignoreCampaignState'] = this.ignoreCampaignState;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    if (typeof this.recipientCampaignStepId !== 'undefined') {
      toReturn['recipientCampaignStepId'] = this.recipientCampaignStepId;
    }
    return toReturn;
  }
}
class Sender {
  static fromProto(proto) {
    let m = new Sender();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(SenderType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class SenderOptions {
  static fromProto(proto) {
    let m = new SenderOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.replyTo !== 'undefined') {
      toReturn['replyTo'] = this.replyTo;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.sendFromAssignedSalesperson !== 'undefined') {
      toReturn['sendFromAssignedSalesperson'] = this.sendFromAssignedSalesperson;
    }
    return toReturn;
  }
}
class SortOptions {
  static fromProto(proto) {
    let m = new SortOptions();
    m = Object.assign(m, proto);
    if (proto.field) {
      m.field = enumStringToValue(SortField, proto.field);
    }
    if (proto.direction) {
      m.direction = enumStringToValue(SortDirection, proto.direction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    return toReturn;
  }
}
class GetCampaignStepContentRequestStepDataEntry {
  static fromProto(proto) {
    let m = new GetCampaignStepContentRequestStepDataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class SendCampaignStepTestEmailRequestStepDataEntry {
  static fromProto(proto) {
    let m = new SendCampaignStepTestEmailRequestStepDataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class StepDataResponse {
  static fromProto(proto) {
    let m = new StepDataResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    return toReturn;
  }
}
class UnpauseCampaignRequest {
  static fromProto(proto) {
    let m = new UnpauseCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class UpdateCampaignNameRequest {
  static fromProto(proto) {
    let m = new UpdateCampaignNameRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class UpdateConfigRequest {
  static fromProto(proto) {
    let m = new UpdateConfigRequest();
    m = Object.assign(m, proto);
    if (proto.daysEmailsCanBeSent) {
      m.daysEmailsCanBeSent = proto.daysEmailsCanBeSent.map(v => enumStringToValue(DaysOfTheWeek, v));
    }
    if (proto.recipientsAddedRateLimit) {
      m.recipientsAddedRateLimit = parseInt(proto.recipientsAddedRateLimit, 10);
    }
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.timeZoneForEmailsSent !== 'undefined') {
      toReturn['timeZoneForEmailsSent'] = this.timeZoneForEmailsSent;
    }
    if (typeof this.daysEmailsCanBeSent !== 'undefined') {
      toReturn['daysEmailsCanBeSent'] = this.daysEmailsCanBeSent;
    }
    if (typeof this.recipientsAddedRateLimitEnabled !== 'undefined') {
      toReturn['recipientsAddedRateLimitEnabled'] = this.recipientsAddedRateLimitEnabled;
    }
    if (typeof this.recipientsAddedRateLimit !== 'undefined') {
      toReturn['recipientsAddedRateLimit'] = this.recipientsAddedRateLimit;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.emailSchedulingDay !== 'undefined') {
      toReturn['emailSchedulingDay'] = this.emailSchedulingDay;
    }
    return toReturn;
  }
}
class UpdateConfigResponse {
  static fromProto(proto) {
    let m = new UpdateConfigResponse();
    m = Object.assign(m, proto);
    if (proto.rateLimit) {
      m.rateLimit = parseInt(proto.rateLimit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.timezone !== 'undefined') {
      toReturn['timezone'] = this.timezone;
    }
    if (typeof this.days !== 'undefined') {
      toReturn['days'] = this.days;
    }
    if (typeof this.rateLimited !== 'undefined') {
      toReturn['rateLimited'] = this.rateLimited;
    }
    if (typeof this.rateLimit !== 'undefined') {
      toReturn['rateLimit'] = this.rateLimit;
    }
    return toReturn;
  }
}
class UpdateEmailTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateEmailTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.htmlBody !== 'undefined') {
      toReturn['htmlBody'] = this.htmlBody;
    }
    if (typeof this.fullHtml !== 'undefined') {
      toReturn['fullHtml'] = this.fullHtml;
    }
    if (typeof this.updatedByUserEmail !== 'undefined') {
      toReturn['updatedByUserEmail'] = this.updatedByUserEmail;
    }
    return toReturn;
  }
}
class UpdateQuotaLimitRequest {
  static fromProto(proto) {
    let m = new UpdateQuotaLimitRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.type) {
      m.type = enumStringToValue(CampaignQuotaCategory, proto.type);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    return toReturn;
  }
}
class UpdateRecipientRequest {
  static fromProto(proto) {
    let m = new UpdateRecipientRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.recipient) {
      m.recipient = RecipientV2.fromProto(proto.recipient);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    return toReturn;
  }
}
class UpdateRequest {
  static fromProto(proto) {
    let m = new UpdateRequest();
    m = Object.assign(m, proto);
    if (proto.emailBuilderTemplate) {
      m.emailBuilderTemplate = EmailBuilderTemplate.fromProto(proto.emailBuilderTemplate);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailBuilderTemplate !== 'undefined' && this.emailBuilderTemplate !== null) {
      toReturn['emailBuilderTemplate'] = 'toApiJson' in this.emailBuilderTemplate ? this.emailBuilderTemplate.toApiJson() : this.emailBuilderTemplate;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateStepOnCampaignRequest {
  static fromProto(proto) {
    let m = new UpdateStepOnCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.secondsAfterLastStep) {
      m.secondsAfterLastStep = parseInt(proto.secondsAfterLastStep, 10);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignStepId !== 'undefined') {
      toReturn['campaignStepId'] = this.campaignStepId;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.contentId !== 'undefined') {
      toReturn['contentId'] = this.contentId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.secondsAfterLastStep !== 'undefined') {
      toReturn['secondsAfterLastStep'] = this.secondsAfterLastStep;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class UpsertCampaignRequest {
  static fromProto(proto) {
    let m = new UpsertCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.focus) {
      m.focus = enumStringToValue(Focuses, proto.focus);
    }
    if (proto.status) {
      m.status = enumStringToValue(Statuses, proto.status);
    }
    if (proto.campaignSchedule) {
      m.campaignSchedule = proto.campaignSchedule.map(CampaignStepInterface.fromProto);
    }
    if (proto.campaignScheduleVersion) {
      m.campaignScheduleVersion = parseInt(proto.campaignScheduleVersion, 10);
    }
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.published) {
      m.published = new Date(proto.published);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.focus !== 'undefined') {
      toReturn['focus'] = this.focus;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.parentCampaignId !== 'undefined') {
      toReturn['parentCampaignId'] = this.parentCampaignId;
    }
    if (typeof this.rootCampaignId !== 'undefined') {
      toReturn['rootCampaignId'] = this.rootCampaignId;
    }
    if (typeof this.createdUser !== 'undefined') {
      toReturn['createdUser'] = this.createdUser;
    }
    if (typeof this.updatedUser !== 'undefined') {
      toReturn['updatedUser'] = this.updatedUser;
    }
    if (typeof this.publishedUser !== 'undefined') {
      toReturn['publishedUser'] = this.publishedUser;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.campaignSchedule !== 'undefined' && this.campaignSchedule !== null) {
      toReturn['campaignSchedule'] = 'toApiJson' in this.campaignSchedule ? this.campaignSchedule.toApiJson() : this.campaignSchedule;
    }
    if (typeof this.isEnabled !== 'undefined') {
      toReturn['isEnabled'] = this.isEnabled;
    }
    if (typeof this.hiddenForPartners !== 'undefined') {
      toReturn['hiddenForPartners'] = this.hiddenForPartners;
    }
    if (typeof this.campaignScheduleVersion !== 'undefined') {
      toReturn['campaignScheduleVersion'] = this.campaignScheduleVersion;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.published !== 'undefined' && this.published !== null) {
      toReturn['published'] = 'toApiJson' in this.published ? this.published.toApiJson() : this.published;
    }
    if (typeof this.emailCategoryId !== 'undefined') {
      toReturn['emailCategoryId'] = this.emailCategoryId;
    }
    if (typeof this.isPremade !== 'undefined') {
      toReturn['isPremade'] = this.isPremade;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    return toReturn;
  }
}
class UpsertConfigRequest {
  static fromProto(proto) {
    let m = new UpsertConfigRequest();
    m = Object.assign(m, proto);
    if (proto.daysEmailsCanBeSent) {
      m.daysEmailsCanBeSent = proto.daysEmailsCanBeSent.map(v => enumStringToValue(DaysOfTheWeek, v));
    }
    if (proto.recipientsAddedRateLimit) {
      m.recipientsAddedRateLimit = parseInt(proto.recipientsAddedRateLimit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.timeZoneForEmailsSent !== 'undefined') {
      toReturn['timeZoneForEmailsSent'] = this.timeZoneForEmailsSent;
    }
    if (typeof this.daysEmailsCanBeSent !== 'undefined') {
      toReturn['daysEmailsCanBeSent'] = this.daysEmailsCanBeSent;
    }
    if (typeof this.recipientsAddedRateLimitEnabled !== 'undefined') {
      toReturn['recipientsAddedRateLimitEnabled'] = this.recipientsAddedRateLimitEnabled;
    }
    if (typeof this.recipientsAddedRateLimit !== 'undefined') {
      toReturn['recipientsAddedRateLimit'] = this.recipientsAddedRateLimit;
    }
    return toReturn;
  }
}
class UpsertRecipientCampaignActivatedEventRequest {
  static fromProto(proto) {
    let m = new UpsertRecipientCampaignActivatedEventRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.fromId !== 'undefined') {
      toReturn['fromId'] = this.fromId;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertRecipientCampaignRequest {
  static fromProto(proto) {
    let m = new UpsertRecipientCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue(CampaignScheduleStatus, proto.status);
    }
    if (proto.schedule) {
      m.schedule = proto.schedule.map(ScheduledCampaignStepInterface.fromProto);
    }
    if (proto.scheduleStep) {
      m.scheduleStep = parseInt(proto.scheduleStep, 10);
    }
    if (proto.pausedDateTime) {
      m.pausedDateTime = new Date(proto.pausedDateTime);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.recipientCampaignId !== 'undefined') {
      toReturn['recipientCampaignId'] = this.recipientCampaignId;
    }
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.fromId !== 'undefined') {
      toReturn['fromId'] = this.fromId;
    }
    if (typeof this.fromEmail !== 'undefined') {
      toReturn['fromEmail'] = this.fromEmail;
    }
    if (typeof this.fromName !== 'undefined') {
      toReturn['fromName'] = this.fromName;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    if (typeof this.isCompleted !== 'undefined') {
      toReturn['isCompleted'] = this.isCompleted;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.schedule !== 'undefined' && this.schedule !== null) {
      toReturn['schedule'] = 'toApiJson' in this.schedule ? this.schedule.toApiJson() : this.schedule;
    }
    if (typeof this.scheduleStep !== 'undefined') {
      toReturn['scheduleStep'] = this.scheduleStep;
    }
    if (typeof this.errorMessage !== 'undefined') {
      toReturn['errorMessage'] = this.errorMessage;
    }
    if (typeof this.pausedDateTime !== 'undefined' && this.pausedDateTime !== null) {
      toReturn['pausedDateTime'] = 'toApiJson' in this.pausedDateTime ? this.pausedDateTime.toApiJson() : this.pausedDateTime;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.replyTo !== 'undefined') {
      toReturn['replyTo'] = this.replyTo;
    }
    if (typeof this.sendNow !== 'undefined') {
      toReturn['sendNow'] = this.sendNow;
    }
    return toReturn;
  }
}
class UpsertRecipientCampaignStepEventRequest {
  static fromProto(proto) {
    let m = new UpsertRecipientCampaignStepEventRequest();
    m = Object.assign(m, proto);
    if (proto.stepEvent) {
      m.stepEvent = RecipientCampaignStepEventStruct.fromProto(proto.stepEvent);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stepEvent !== 'undefined' && this.stepEvent !== null) {
      toReturn['stepEvent'] = 'toApiJson' in this.stepEvent ? this.stepEvent.toApiJson() : this.stepEvent;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'campaigns-api.vendasta-local.com',
  'test': '',
  'demo': 'campaigns-demo.apigateway.co',
  'prod': 'campaigns-prod.apigateway.co',
  'production': 'campaigns-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ActivationsApiService = /*#__PURE__*/(() => {
  class ActivationsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    activateProductForSender(r) {
      const request = r.toApiJson ? r : new ActivateProductForSenderRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Activations/ActivateProductForSender", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    isProductActive(r) {
      const request = r.toApiJson ? r : new IsProductActiveForSenderRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Activations/IsProductActive", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsProductActiveForSenderResponse.fromProto(resp)));
    }
    deactivateProduct(r) {
      const request = r.toApiJson ? r : new DeactivateProductForSenderRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Activations/DeactivateProduct", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    isFeatureActive(r) {
      const request = r.toApiJson ? r : new IsFeatureActiveForSenderRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Activations/IsFeatureActive", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsFeatureActiveForSenderResponse.fromProto(resp)));
    }
  }
  ActivationsApiService.ɵfac = function ActivationsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ActivationsApiService)();
  };
  ActivationsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ActivationsApiService,
    factory: ActivationsApiService.ɵfac,
    providedIn: 'root'
  });
  return ActivationsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CampaignConfigApiService = /*#__PURE__*/(() => {
  class CampaignConfigApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsertConfig(r) {
      const request = r.toApiJson ? r : new UpsertConfigRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignConfig/UpsertConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getConfig(r) {
      const request = r.toApiJson ? r : new GetConfigRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignConfig/GetConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateConfigRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignConfig/UpdateConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateConfigResponse.fromProto(resp)));
    }
  }
  CampaignConfigApiService.ɵfac = function CampaignConfigApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignConfigApiService)();
  };
  CampaignConfigApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignConfigApiService,
    factory: CampaignConfigApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignConfigApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CampaignQuotaApiService = /*#__PURE__*/(() => {
  class CampaignQuotaApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getCampaignQuota(r) {
      const request = r.toApiJson ? r : new GetCampaignQuotaRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignQuota/GetCampaignQuota", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCampaignQuotaResponse.fromProto(resp)));
    }
    createQuota(r) {
      const request = r.toApiJson ? r : new CreateQuotaRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignQuota/CreateQuota", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateQuotaLimit(r) {
      const request = r.toApiJson ? r : new UpdateQuotaLimitRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignQuota/UpdateQuotaLimit", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CampaignQuotaApiService.ɵfac = function CampaignQuotaApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignQuotaApiService)();
  };
  CampaignQuotaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignQuotaApiService,
    factory: CampaignQuotaApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignQuotaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CampaignStatsApiService = /*#__PURE__*/(() => {
  class CampaignStatsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAggregatedCampaignStats(r) {
      const request = r.toApiJson ? r : new GetAggregatedCampaignStatsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignStats/GetAggregatedCampaignStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAggregatedCampaignStatsResponse.fromProto(resp)));
    }
    listCampaignStats(r) {
      const request = r.toApiJson ? r : new ListCampaignStatsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignStats/ListCampaignStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCampaignStatsResponse.fromProto(resp)));
    }
    getCampaignDetailsStats(r) {
      const request = r.toApiJson ? r : new GetCampaignDetailsStatsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignStats/GetCampaignDetailsStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCampaignDetailsStatsResponse.fromProto(resp)));
    }
    getLinkStats(r) {
      const request = r.toApiJson ? r : new GetLinkStatsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignStats/GetLinkStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLinkStatsResponse.fromProto(resp)));
    }
    getRecipientLinkClickStats(r) {
      const request = r.toApiJson ? r : new GetRecipientLinkClickStatsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignStats/GetRecipientLinkClickStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRecipientLinkClickStatsResponse.fromProto(resp)));
    }
    getCampaignStepStats(r) {
      const request = r.toApiJson ? r : new GetCampaignStepStatsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignStats/GetCampaignStepStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCampaignStepStatsResponse.fromProto(resp)));
    }
    exportRecipientLinkClickStats(r) {
      const request = r.toApiJson ? r : new ExportRecipientLinkClickStatsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignStats/ExportRecipientLinkClickStats", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listCampaignStatsForSender(r) {
      const request = r.toApiJson ? r : new ListCampaignStatsForSenderRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignStats/ListCampaignStatsForSender", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCampaignStatsForSenderResponse.fromProto(resp)));
    }
  }
  CampaignStatsApiService.ɵfac = function CampaignStatsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignStatsApiService)();
  };
  CampaignStatsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignStatsApiService,
    factory: CampaignStatsApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignStatsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CampaignTaggingApiService = /*#__PURE__*/(() => {
  class CampaignTaggingApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateTagRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignTagging/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTagResponse.fromProto(resp)));
    }
    listTagsForSender(r) {
      const request = r.toApiJson ? r : new ListTagsForSenderRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignTagging/ListTagsForSender", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTagsForSenderResponse.fromProto(resp)));
    }
    addTagToCampaign(r) {
      const request = r.toApiJson ? r : new AddTagToCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignTagging/AddTagToCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeTagFromCampaign(r) {
      const request = r.toApiJson ? r : new RemoveTagFromCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignTagging/RemoveTagFromCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listTagsForCampaign(r) {
      const request = r.toApiJson ? r : new ListTagsForCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignTagging/ListTagsForCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTagsForCampaignResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteTagRequest(r);
      return this.http.post(this._host + "/campaigns.v1.CampaignTagging/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CampaignTaggingApiService.ɵfac = function CampaignTaggingApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignTaggingApiService)();
  };
  CampaignTaggingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignTaggingApiService,
    factory: CampaignTaggingApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignTaggingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CampaignsApiService = /*#__PURE__*/(() => {
  class CampaignsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    deleteCampaign(r) {
      const request = r.toApiJson ? r : new DeleteCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/DeleteCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    upsertCampaign(r) {
      const request = r.toApiJson ? r : new UpsertCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/UpsertCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateCampaignName(r) {
      const request = r.toApiJson ? r : new UpdateCampaignNameRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/UpdateCampaignName", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listCampaigns(r) {
      const request = r.toApiJson ? r : new ListCampaignsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/ListCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCampaignsResponse.fromProto(resp)));
    }
    listRecommendedCampaigns(r) {
      const request = r.toApiJson ? r : new ListRecommendedCampaignsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/ListRecommendedCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCampaignsResponse.fromProto(resp)));
    }
    getCampaign(r) {
      const request = r.toApiJson ? r : new GetCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/GetCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCampaignResponse.fromProto(resp)));
    }
    getMultiCampaigns(r) {
      const request = r.toApiJson ? r : new GetMultiCampaignsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/GetMultiCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCampaignsResponse.fromProto(resp)));
    }
    duplicateCampaignStepAsync(r) {
      const request = r.toApiJson ? r : new DuplicateCampaignStepRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/DuplicateCampaignStepAsync", request.toApiJson(), this.apiOptions()).pipe(map(resp => DuplicateCampaignStepResponse.fromProto(resp)));
    }
    checkDuplicateCampaignStepStatus(r) {
      const request = r.toApiJson ? r : new CheckDuplicateCampaignStepStatusRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/CheckDuplicateCampaignStepStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => CheckDuplicateCampaignStepStatusResponse.fromProto(resp)));
    }
    duplicateCampaignAsync(r) {
      const request = r.toApiJson ? r : new DuplicateCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/DuplicateCampaignAsync", request.toApiJson(), this.apiOptions()).pipe(map(resp => DuplicateCampaignResponse.fromProto(resp)));
    }
    duplicateCampaignAsyncV2(r) {
      const request = r.toApiJson ? r : new DuplicateCampaignRequestV2(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/DuplicateCampaignAsyncV2", request.toApiJson(), this.apiOptions()).pipe(map(resp => DuplicateCampaignResponse.fromProto(resp)));
    }
    checkDuplicateCampaignStatus(r) {
      const request = r.toApiJson ? r : new CheckDuplicateCampaignStatusRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/CheckDuplicateCampaignStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => CheckDuplicateCampaignStatusResponse.fromProto(resp)));
    }
    duplicateAndRecommendCampaign(r) {
      const request = r.toApiJson ? r : new DuplicateAndRecommendCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/DuplicateAndRecommendCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendRecipientCampaignStepEmail(r) {
      const request = r.toApiJson ? r : new SendRecipientCampaignStepEmailRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/SendRecipientCampaignStepEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    executeStep(r) {
      const request = r.toApiJson ? r : new ExecuteStepRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/ExecuteStep", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createCampaign(r) {
      const request = r.toApiJson ? r : new CreateCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/CreateCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCampaignResponse.fromProto(resp)));
    }
    addStepToCampaign(r) {
      const request = r.toApiJson ? r : new AddStepToCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/AddStepToCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => StepDataResponse.fromProto(resp)));
    }
    getCampaignStepContent(r) {
      const request = r.toApiJson ? r : new GetCampaignStepContentRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/GetCampaignStepContent", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCampaignStepContentResponse.fromProto(resp)));
    }
    sendCampaignStepTestEmail(r) {
      const request = r.toApiJson ? r : new SendCampaignStepTestEmailRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/SendCampaignStepTestEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendCampaignStepTestEmailResponse.fromProto(resp)));
    }
    updateStepOnCampaign(r) {
      const request = r.toApiJson ? r : new UpdateStepOnCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/UpdateStepOnCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => StepDataResponse.fromProto(resp)));
    }
    listCampaignsV2(r) {
      const request = r.toApiJson ? r : new ListCampaignsV2Request(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/ListCampaignsV2", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCampaignsV2Response.fromProto(resp)));
    }
    pauseCampaign(r) {
      const request = r.toApiJson ? r : new PauseCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/PauseCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unpauseCampaign(r) {
      const request = r.toApiJson ? r : new UnpauseCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/UnpauseCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAvailableStepTypesForSender(r) {
      const request = r.toApiJson ? r : new GetAvailableStepTypesForSenderRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Campaigns/GetAvailableStepTypesForSender", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAvailableStepTypesForSenderResponse.fromProto(resp)));
    }
  }
  CampaignsApiService.ɵfac = function CampaignsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignsApiService)();
  };
  CampaignsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignsApiService,
    factory: CampaignsApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let EmailBuilderApiService = /*#__PURE__*/(() => {
  class EmailBuilderApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailBuilder/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailBuilder/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailBuilder/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailBuilder/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    render(r) {
      const request = r.toApiJson ? r : new RenderRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailBuilder/Render", request.toApiJson(), this.apiOptions()).pipe(map(resp => RenderResponse.fromProto(resp)));
    }
    convert(r) {
      const request = r.toApiJson ? r : new ConvertLegacyTemplateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailBuilder/Convert", request.toApiJson(), this.apiOptions()).pipe(map(resp => ConvertLegacyTemplateResponse.fromProto(resp)));
    }
  }
  EmailBuilderApiService.ɵfac = function EmailBuilderApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailBuilderApiService)();
  };
  EmailBuilderApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailBuilderApiService,
    factory: EmailBuilderApiService.ɵfac,
    providedIn: 'root'
  });
  return EmailBuilderApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let EmailTemplateApiService = /*#__PURE__*/(() => {
  class EmailTemplateApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createEmailTemplate(r) {
      const request = r.toApiJson ? r : new CreateEmailTemplateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailTemplate/CreateEmailTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateEmailTemplate(r) {
      const request = r.toApiJson ? r : new UpdateEmailTemplateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailTemplate/UpdateEmailTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getEmailTemplate(r) {
      const request = r.toApiJson ? r : new GetEmailTemplateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailTemplate/GetEmailTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmailTemplateResponse.fromProto(resp)));
    }
    getEmailTemplates(r) {
      const request = r.toApiJson ? r : new GetEmailTemplatesRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailTemplate/GetEmailTemplates", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmailTemplatesResponse.fromProto(resp)));
    }
    previewEmailTemplate(r) {
      const request = r.toApiJson ? r : new PreviewEmailTemplateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailTemplate/PreviewEmailTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => PreviewEmailTemplateResponse.fromProto(resp)));
    }
    listLinksInTemplate(r) {
      const request = r.toApiJson ? r : new ListLinksInTemplateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailTemplate/ListLinksInTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListLinksInTemplateResponse.fromProto(resp)));
    }
    extractLinkTrackingDataForTemplate(r) {
      const request = r.toApiJson ? r : new ExtractLinkTrackingDataForTemplateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailTemplate/ExtractLinkTrackingDataForTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => ExtractLinkTrackingDataForTemplateResponse.fromProto(resp)));
    }
    sendPreview(r) {
      const request = r.toApiJson ? r : new SendPreviewEmailRequest(r);
      return this.http.post(this._host + "/campaigns.v1.EmailTemplate/SendPreview", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  EmailTemplateApiService.ɵfac = function EmailTemplateApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailTemplateApiService)();
  };
  EmailTemplateApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailTemplateApiService,
    factory: EmailTemplateApiService.ɵfac,
    providedIn: 'root'
  });
  return EmailTemplateApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let LegacyAppengineAPIApiService = /*#__PURE__*/(() => {
  class LegacyAppengineAPIApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    rateLimitedAddAccountGroupToCampaign(r) {
      const request = r.toApiJson ? r : new LegacyAddAccountGroupToCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.LegacyAppengineAPIService/RateLimitedAddAccountGroupToCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    rateLimitedAddToCampaign(r) {
      const request = r.toApiJson ? r : new LegacyRateLimitedAddToCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.LegacyAppengineAPIService/RateLimitedAddToCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => LegacyRateLimitedAddToCampaignResponse.fromProto(resp)));
    }
    pauseAccountGroupOnCampaign(r) {
      const request = r.toApiJson ? r : new LegacyPauseAccountGroupOnCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.LegacyAppengineAPIService/PauseAccountGroupOnCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getRecipientCampaignsByAgid(r) {
      const request = r.toApiJson ? r : new LegacyGetRecipientCampaignsByAgidRequest(r);
      return this.http.post(this._host + "/campaigns.v1.LegacyAppengineAPIService/GetRecipientCampaignsByAgid", request.toApiJson(), this.apiOptions()).pipe(map(resp => LegacyGetRecipientCampaignsByAgidResponse.fromProto(resp)));
    }
    updateRecipientCampaignStatus(r) {
      const request = r.toApiJson ? r : new LegacyUpdateRecipientCampaignStatusRequest(r);
      return this.http.post(this._host + "/campaigns.v1.LegacyAppengineAPIService/UpdateRecipientCampaignStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  LegacyAppengineAPIApiService.ɵfac = function LegacyAppengineAPIApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LegacyAppengineAPIApiService)();
  };
  LegacyAppengineAPIApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LegacyAppengineAPIApiService,
    factory: LegacyAppengineAPIApiService.ɵfac,
    providedIn: 'root'
  });
  return LegacyAppengineAPIApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RecipientApiService = /*#__PURE__*/(() => {
  class RecipientApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createRecipient(r) {
      const request = r.toApiJson ? r : new CreateRecipientRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Recipient/CreateRecipient", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateRecipient(r) {
      const request = r.toApiJson ? r : new UpdateRecipientRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Recipient/UpdateRecipient", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getRecipient(r) {
      const request = r.toApiJson ? r : new GetRecipientRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Recipient/GetRecipient", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRecipientResponse.fromProto(resp)));
    }
    listRecipients(r) {
      const request = r.toApiJson ? r : new ListRecipientsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Recipient/ListRecipients", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListRecipientsResponse.fromProto(resp)));
    }
  }
  RecipientApiService.ɵfac = function RecipientApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RecipientApiService)();
  };
  RecipientApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecipientApiService,
    factory: RecipientApiService.ɵfac,
    providedIn: 'root'
  });
  return RecipientApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RecipientCampaignApiService = /*#__PURE__*/(() => {
  class RecipientCampaignApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsertRecipientCampaign(r) {
      const request = r.toApiJson ? r : new UpsertRecipientCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/UpsertRecipientCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listRecipientCampaigns(r) {
      const request = r.toApiJson ? r : new ListRecipientCampaignsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/ListRecipientCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListRecipientCampaignsResponse.fromProto(resp)));
    }
    pauseRecipientCampaign(r) {
      const request = r.toApiJson ? r : new PauseRecipientCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/PauseRecipientCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    resumeRecipientCampaign(r) {
      const request = r.toApiJson ? r : new ResumeRecipientCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/ResumeRecipientCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getRecipientCampaign(r) {
      const request = r.toApiJson ? r : new GetRecipientCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/GetRecipientCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRecipientCampaignResponse.fromProto(resp)));
    }
    lookupRecipientCampaign(r) {
      const request = r.toApiJson ? r : new LookupRecipientCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/LookupRecipientCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupRecipientCampaignResponse.fromProto(resp)));
    }
    lookupRecipientCampaigns(r) {
      const request = r.toApiJson ? r : new LookupRecipientCampaignsRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/LookupRecipientCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupRecipientCampaignsResponse.fromProto(resp)));
    }
    addContactToCampaign(r) {
      const request = r.toApiJson ? r : new AddContactToCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/AddContactToCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddContactToCampaignResponse.fromProto(resp)));
    }
    bulkAddContactsToCampaign(r) {
      const request = r.toApiJson ? r : new BulkAddContactsToCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/BulkAddContactsToCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkAddContactsIdsToCampaign(r) {
      const request = r.toApiJson ? r : new BulkAddContactIdsToCampaignRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaign/BulkAddContactsIdsToCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  RecipientCampaignApiService.ɵfac = function RecipientCampaignApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RecipientCampaignApiService)();
  };
  RecipientCampaignApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecipientCampaignApiService,
    factory: RecipientCampaignApiService.ɵfac,
    providedIn: 'root'
  });
  return RecipientCampaignApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RecipientCampaignActivatedEventApiService = /*#__PURE__*/(() => {
  class RecipientCampaignActivatedEventApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsertRecipientCampaignActivatedEvent(r) {
      const request = r.toApiJson ? r : new UpsertRecipientCampaignActivatedEventRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaignActivatedEvent/UpsertRecipientCampaignActivatedEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  RecipientCampaignActivatedEventApiService.ɵfac = function RecipientCampaignActivatedEventApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RecipientCampaignActivatedEventApiService)();
  };
  RecipientCampaignActivatedEventApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecipientCampaignActivatedEventApiService,
    factory: RecipientCampaignActivatedEventApiService.ɵfac,
    providedIn: 'root'
  });
  return RecipientCampaignActivatedEventApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RecipientCampaignStepEventApiService = /*#__PURE__*/(() => {
  class RecipientCampaignStepEventApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createRecipientCampaignStepEvent(r) {
      const request = r.toApiJson ? r : new CreateRecipientCampaignStepEventRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaignStepEvent/CreateRecipientCampaignStepEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    upsertRecipientCampaignStepEvent(r) {
      const request = r.toApiJson ? r : new UpsertRecipientCampaignStepEventRequest(r);
      return this.http.post(this._host + "/campaigns.v1.RecipientCampaignStepEvent/UpsertRecipientCampaignStepEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  RecipientCampaignStepEventApiService.ɵfac = function RecipientCampaignStepEventApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RecipientCampaignStepEventApiService)();
  };
  RecipientCampaignStepEventApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecipientCampaignStepEventApiService,
    factory: RecipientCampaignStepEventApiService.ɵfac,
    providedIn: 'root'
  });
  return RecipientCampaignStepEventApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TemplatesApiService = /*#__PURE__*/(() => {
  class TemplatesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateTemplateRequest(r);
      return this.http.post(this._host + "/campaigns.v1.Templates/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  TemplatesApiService.ɵfac = function TemplatesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TemplatesApiService)();
  };
  TemplatesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TemplatesApiService,
    factory: TemplatesApiService.ɵfac,
    providedIn: 'root'
  });
  return TemplatesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * AllDates is a DateFilter which does not apply any filtering. When used in a
 * filter, you can expect to be returned data which spans all possible dates.
 */
const AllDates = new DateFilter();
let CampaignService = /*#__PURE__*/(() => {
  class CampaignService {
    constructor(api) {
      this.api = api;
    }
    create(sender, name) {
      return this.api.createCampaign({
        name: name,
        sender: sender,
        focus: Focuses.FOCUSES_NONE
      }).pipe(map(v => v.campaignId));
    }
    delete(campaignId) {
      return this.api.deleteCampaign({
        campaignId: campaignId
      }).pipe(map(() => null));
    }
    addStep(sender, campaignId, stepType, contentId, name) {
      const req = {
        campaignId: campaignId,
        stepType: stepType,
        contentId: contentId,
        sender: sender,
        name: name
      };
      return this.api.addStepToCampaign(req).pipe(map(resp => resp));
    }
    updateStep(sender, campaignId, campaignStepId, contentId, name, secondsAfterLastStep, fm) {
      const req = {
        campaignId: campaignId,
        campaignStepId: campaignStepId,
        contentId: contentId,
        sender: sender,
        name: name,
        secondsAfterLastStep: secondsAfterLastStep,
        fieldMask: fm
      };
      return this.api.updateStepOnCampaign(req).pipe(map(resp => resp));
    }
    get(campaignID) {
      return this.api.getCampaign({
        campaignId: campaignID
      }).pipe(map(resp => resp.campaign), map(campaign => {
        campaign.campaignSchedule = campaign.campaignSchedule || [];
        return campaign;
      }));
    }
    getMulti(campaignIDs) {
      return this.api.getMultiCampaigns({
        campaignIds: campaignIDs
      }).pipe(map(resp => resp.campaigns));
    }
    list(partnerID, focuses, statuses, name, pagingOptions) {
      return this.api.listCampaigns(new ListCampaignsRequest({
        partnerId: partnerID,
        focuses: focuses || [],
        statuses: statuses || [],
        pagingOptions: pagingOptions || {},
        name: name
      })).pipe(map(v => (v.campaigns || []).map(vv => {
        vv.campaignSchedule = vv.campaignSchedule || [];
        vv.hiddenForPartners = vv.hiddenForPartners || [];
        return vv;
      })));
    }
    listRecommendedCampaigns(data) {
      return this.api.listRecommendedCampaigns({
        focuses: data.focuses,
        statuses: data.statuses,
        pagingOptions: data.pagingOptions
      }).pipe(map(resp => resp));
    }
    duplicateCampaignStepAsync(campaignId, stepId) {
      const req = {
        campaignId: campaignId,
        campaignStepId: stepId
      };
      return this.api.duplicateCampaignStepAsync(req).pipe(map(v => v.statusId));
    }
    checkCampaignStepDuplicateStatus(workflowStatusId) {
      const req = {
        statusId: workflowStatusId
      };
      return this.api.checkDuplicateCampaignStepStatus(req).pipe(map(v => v.status));
    }
    duplicateCampaignAsync(campaignId, targetPartnerId) {
      const req = {
        campaignId: campaignId,
        partnerId: targetPartnerId
      };
      return this.api.duplicateCampaignAsync(req).pipe(map(v => v.statusId));
    }
    duplicateCampaignAsyncV2(campaignId, sender) {
      const req = {
        campaignId: campaignId,
        sender: sender
      };
      return this.api.duplicateCampaignAsyncV2(req).pipe(map(v => v.statusId));
    }
    checkCampaignDuplicateStatus(workflowStatusId) {
      const req = {
        statusId: workflowStatusId
      };
      return this.api.checkDuplicateCampaignStatus(req);
    }
    getEmailStepContent(campaignId, campaignStepId, data) {
      return this.api.getCampaignStepContent({
        campaignId: campaignId,
        campaignStepId: campaignStepId,
        stepData: data
      });
    }
    sendStepTestEmail(sender, campaignId, campaignStepId, sendToUserId, data) {
      return this.api.sendCampaignStepTestEmail({
        sender: sender,
        campaignId: campaignId,
        campaignStepId: campaignStepId,
        sendToUserId: sendToUserId,
        stepData: data
      });
    }
    updateStatus(sender, campaignID, status) {
      return this.api.upsertCampaign({
        sender: sender,
        campaignId: campaignID,
        status: status,
        fieldMask: {
          paths: ["Status"]
        }
      }).pipe(mapTo(undefined));
    }
    updateName(sender, campaignID, name) {
      return this.api.upsertCampaign({
        sender: sender,
        campaignId: campaignID,
        name: name,
        fieldMask: {
          paths: ["Name"]
        }
      }).pipe(mapTo(undefined));
    }
    updateCampaignSchedule(sender, campaignID, campaignSchedule) {
      return this.api.upsertCampaign({
        sender: sender,
        campaignId: campaignID,
        campaignSchedule: campaignSchedule,
        fieldMask: {
          paths: ["CampaignSchedule"]
        }
      }).pipe(mapTo(undefined));
    }
    updateCampaignLocale(sender, campaignID, locale) {
      return this.api.upsertCampaign({
        sender: sender,
        campaignId: campaignID,
        locale: locale,
        fieldMask: {
          paths: ["Locale"]
        }
      }).pipe(mapTo(undefined));
    }
    listCampaignsV2(sender, statuses, searchTerm, pagingOptions, sortOptions) {
      return this.api.listCampaignsV2({
        sender: sender,
        statuses: statuses || [],
        pagingOptions: pagingOptions || {},
        searchTerm: searchTerm,
        sortOptions: sortOptions || {}
      }).pipe(map(resp => resp));
    }
    pauseCampaign(campaignId) {
      return this.api.pauseCampaign({
        campaignId: campaignId
      }).pipe(mapTo(undefined));
    }
    unpauseCampaign(campaignId) {
      return this.api.unpauseCampaign({
        campaignId: campaignId
      }).pipe(mapTo(undefined));
    }
    getAvailableStepTypesForSender(sender) {
      return this.api.getAvailableStepTypesForSender({
        sender: sender
      }).pipe(map(resp => resp));
    }
  }
  CampaignService.ɵfac = function CampaignService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignService)(i0.ɵɵinject(CampaignsApiService));
  };
  CampaignService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignService,
    factory: CampaignService.ɵfac,
    providedIn: 'root'
  });
  return CampaignService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RecipientCampaignService = /*#__PURE__*/(() => {
  class RecipientCampaignService {
    constructor(api) {
      this.api = api;
    }
    list(accountGroupID) {
      return this.api.listRecipientCampaigns({
        accountGroupId: accountGroupID
      }).pipe(map(resp => resp.recipientCampaign));
    }
    addToCampaign(campaignId, sender, recipient, date, sendNow, senderOptions) {
      return this.api.addContactToCampaign({
        campaignId: campaignId,
        sender: sender,
        recipient: recipient,
        date: date,
        senderOptions: senderOptions,
        sendNow: sendNow
      }).pipe(map(resp => resp));
    }
    bulkAddToCampaign(campaignId, sender, date, sendNow, filterGroup, searchTerm, senderOptions) {
      return this.api.bulkAddContactsToCampaign({
        campaignId: campaignId,
        sender: sender,
        date: date,
        criteria: {
          filterGroupV2: filterGroup,
          searchTerm: searchTerm
        },
        senderOptions: senderOptions,
        sendNow: sendNow
      }).pipe(map(() => null));
    }
    lookupRecipientCampaign(campaignId, sender, recipient) {
      return this.api.lookupRecipientCampaign({
        campaignId: campaignId,
        sender: sender,
        recipient: recipient
      }).pipe(map(resp => resp));
    }
    lookupRecipientCampaigns(campaignId, sender, recipients) {
      return this.api.lookupRecipientCampaigns({
        campaignId: campaignId,
        sender: sender,
        recipients: recipients
      }).pipe(map(resp => resp));
    }
    getRecipientCampaign(recipientCampaignId) {
      return this.api.getRecipientCampaign({
        recipientCampaignId: recipientCampaignId
      }).pipe(map(resp => resp?.recipientCampaign));
    }
    pauseRecipientCampaign(recipientCampaignId) {
      return this.api.pauseRecipientCampaign({
        recipientCampaignId: recipientCampaignId
      }).pipe(mapTo(undefined));
    }
    resumeRecipientCampaign(recipientCampaignId) {
      return this.api.resumeRecipientCampaign({
        recipientCampaignId: recipientCampaignId
      }).pipe(mapTo(undefined));
    }
  }
  RecipientCampaignService.ɵfac = function RecipientCampaignService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RecipientCampaignService)(i0.ɵɵinject(RecipientCampaignApiService));
  };
  RecipientCampaignService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecipientCampaignService,
    factory: RecipientCampaignService.ɵfac,
    providedIn: 'root'
  });
  return RecipientCampaignService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmailTemplateService = /*#__PURE__*/(() => {
  class EmailTemplateService {
    constructor(api) {
      this.api = api;
    }
    get(templateID) {
      return this.api.getEmailTemplate({
        templateId: templateID
      }).pipe(map(resp => resp.template));
    }
    listLinksInTemplate(templateID) {
      return this.api.listLinksInTemplate({
        templateId: templateID
      }).pipe(map(resp => resp.links));
    }
    getMulti(templateIDs) {
      return this.api.getEmailTemplates({
        templateIds: templateIDs
      }).pipe(map(resp => resp.templates));
    }
    previewEmailTemplate(templateId, accountGroupId, partnerId, marketId, locale, userId, sender) {
      const req = {
        templateId: templateId,
        accountGroupId: accountGroupId,
        partnerId: partnerId,
        marketId: marketId,
        locale: locale,
        userId: userId,
        sender: sender
      };
      return this.api.previewEmailTemplate(req).pipe(map(v => ({
        htmlBody: v.templateHtml,
        subject: v.subject,
        name: v.name
      })));
    }
    sendPreview(sender, htmlContent, subject, recipientUserId) {
      const req = {
        sender: sender,
        htmlContent: htmlContent,
        subject: subject,
        recipientUserId: recipientUserId
      };
      return this.api.sendPreview(req);
    }
  }
  EmailTemplateService.ɵfac = function EmailTemplateService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailTemplateService)(i0.ɵɵinject(EmailTemplateApiService));
  };
  EmailTemplateService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailTemplateService,
    factory: EmailTemplateService.ɵfac,
    providedIn: 'root'
  });
  return EmailTemplateService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * EmailBuilderTemplates are used by the new EmailBuilder (from @vendasta/email-ui)
 * to create and edit email templates. They are different from the legacy
 * EmailTemplates because they store their editable content as JSON, not HTML.
 */
let EmailBuilderTemplateService = /*#__PURE__*/(() => {
  class EmailBuilderTemplateService {
    constructor(api) {
      this.api = api;
    }
    createNewTemplate(template) {
      const req = {
        emailBuilderTemplate: template
      };
      return this.api.create(req).pipe(map(v => v.id));
    }
    getTemplate(id) {
      const req = {
        id: id
      };
      return this.api.get(req).pipe(map(v => v.emailBuilderTemplate));
    }
    updateExistingTemplate(template) {
      const req = {
        emailBuilderTemplate: template
      };
      return this.api.update(req).pipe(mapTo(null));
    }
    convertLegacyTemplate(templateId, partnerId) {
      const req = {
        templateId: templateId,
        partnerId: partnerId
      };
      return this.api.convert(req).pipe(map(v => v.templateId));
    }
  }
  EmailBuilderTemplateService.ɵfac = function EmailBuilderTemplateService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailBuilderTemplateService)(i0.ɵɵinject(EmailBuilderApiService));
  };
  EmailBuilderTemplateService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailBuilderTemplateService,
    factory: EmailBuilderTemplateService.ɵfac,
    providedIn: 'root'
  });
  return EmailBuilderTemplateService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CampaignStatsService = /*#__PURE__*/(() => {
  class CampaignStatsService {
    constructor(api) {
      this.api = api;
    }
    get(data) {
      return this.api.getAggregatedCampaignStats(data).pipe(map(resp => resp));
    }
    list(data) {
      return this.api.listCampaignStats(data).pipe(map(resp => {
        resp.stats = resp.stats || [];
        resp.stats = resp.stats.map(stat => {
          stat.tags = stat.tags || [];
          return stat;
        });
        return resp;
      }));
    }
    getCampaignDetailsStats(data) {
      return this.api.getCampaignDetailsStats(data).pipe(map(resp => resp));
    }
    getLinkStats(data) {
      return this.api.getLinkStats(data).pipe(map(resp => resp));
    }
    getRecipientLinkClickStats(data) {
      return this.api.getRecipientLinkClickStats(data);
    }
    getCampaignStepStats(data) {
      return this.api.getCampaignStepStats(data).pipe(map(resp => resp));
    }
    exportRecipientLinkClickStats(data) {
      return this.api.exportRecipientLinkClickStats(data).pipe(map(() => null));
    }
    listStatsForSender(data) {
      return this.api.listCampaignStatsForSender(data).pipe(map(v => {
        v.stats = v.stats || [];
        return v;
      }));
    }
  }
  CampaignStatsService.ɵfac = function CampaignStatsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignStatsService)(i0.ɵɵinject(CampaignStatsApiService));
  };
  CampaignStatsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignStatsService,
    factory: CampaignStatsService.ɵfac,
    providedIn: 'root'
  });
  return CampaignStatsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CampaignTaggingService = /*#__PURE__*/(() => {
  class CampaignTaggingService {
    constructor(api) {
      this.api = api;
    }
    create(senderType, senderId, text, colour) {
      const req = {
        senderType: senderType,
        senderId: senderId,
        text: text,
        colour: colour
      };
      return this.api.create(req).pipe(map(resp => resp.campaignTag));
    }
    listTagsForSender(senderType, senderId, cursor, pageSize) {
      const req = {
        senderType: senderType,
        senderId: senderId,
        cursor: cursor,
        pageSize: pageSize
      };
      return this.api.listTagsForSender(req).pipe(map(v => {
        v.campaignTags = v.campaignTags || [];
        return v;
      }));
    }
    addTagToCampaign(senderType, senderId, campaignId, tagId) {
      const req = {
        senderType: senderType,
        senderId: senderId,
        campaignId: campaignId,
        tagId: tagId
      };
      return this.api.addTagToCampaign(req).pipe(map(() => null));
    }
    removeTagFromCampaign(campaignId, tagId) {
      const req = new RemoveTagFromCampaignRequest({
        campaignId: campaignId,
        tagId: tagId
      });
      return this.api.removeTagFromCampaign(req).pipe(map(() => null));
    }
    listTagsForCampaign(campaignId, cursor, pageSize) {
      const req = {
        campaignId: campaignId,
        cursor: cursor,
        pageSize: pageSize
      };
      return this.api.listTagsForCampaign(req).pipe(map(v => {
        v.campaignTags = v.campaignTags || [];
        return v;
      }));
    }
    deleteTag(senderType, senderId, tagId) {
      const req = {
        senderType: senderType,
        senderId: senderId,
        tagId: tagId
      };
      return this.api.delete(req).pipe(map(() => null));
    }
  }
  CampaignTaggingService.ɵfac = function CampaignTaggingService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignTaggingService)(i0.ɵɵinject(CampaignTaggingApiService));
  };
  CampaignTaggingService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignTaggingService,
    factory: CampaignTaggingService.ɵfac,
    providedIn: 'root'
  });
  return CampaignTaggingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LegacyAppengineService = /*#__PURE__*/(() => {
  class LegacyAppengineService {
    constructor(api) {
      this.api = api;
    }
    updateRecipientCampaignStatus(recipientCampaignId, status) {
      const req = {
        recipientCampaignId: recipientCampaignId,
        status: status
      };
      return this.api.updateRecipientCampaignStatus(req).pipe(map(() => null));
    }
  }
  LegacyAppengineService.ɵfac = function LegacyAppengineService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LegacyAppengineService)(i0.ɵɵinject(LegacyAppengineAPIApiService));
  };
  LegacyAppengineService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LegacyAppengineService,
    factory: LegacyAppengineService.ɵfac,
    providedIn: 'root'
  });
  return LegacyAppengineService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConfigService = /*#__PURE__*/(() => {
  class ConfigService {
    constructor(api) {
      this.api = api;
    }
    getConfig(campaignId) {
      const req = {
        campaignId: campaignId
      };
      return this.api.getConfig(req);
    }
    updateConfig(campaignId, timeZoneForEmailsSent, daysEmailsCanBeSent, recipientsAddedRateLimitEnabled, recipientsAddedRateLimit, sender, emailsCanbeSent) {
      const req = {
        campaignId: campaignId,
        timeZoneForEmailsSent: timeZoneForEmailsSent,
        daysEmailsCanBeSent: daysEmailsCanBeSent,
        recipientsAddedRateLimitEnabled: recipientsAddedRateLimitEnabled,
        recipientsAddedRateLimit: recipientsAddedRateLimit,
        sender: sender,
        emailSchedulingDay: emailsCanbeSent
      };
      return this.api.updateConfig(req);
    }
  }
  ConfigService.ɵfac = function ConfigService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ConfigService)(i0.ɵɵinject(CampaignConfigApiService));
  };
  ConfigService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConfigService,
    factory: ConfigService.ɵfac,
    providedIn: 'root'
  });
  return ConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ActivationService = /*#__PURE__*/(() => {
  class ActivationService {
    constructor(api) {
      this.api = api;
    }
    isFeatureActive(sender, feature) {
      const req = {
        sender: sender,
        featureId: feature
      };
      return this.api.isFeatureActive(req).pipe(map(v => v));
    }
  }
  ActivationService.ɵfac = function ActivationService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ActivationService)(i0.ɵɵinject(ActivationsApiService));
  };
  ActivationService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ActivationService,
    factory: ActivationService.ɵfac,
    providedIn: 'root'
  });
  return ActivationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let QuotaService = /*#__PURE__*/(() => {
  class QuotaService {
    constructor(api) {
      this.api = api;
    }
    getCampaignQuota(sender, type, datePeriod) {
      const req = {
        sender: sender,
        type: type,
        datePeriod: datePeriod
      };
      return this.api.getCampaignQuota(req);
    }
  }
  QuotaService.ɵfac = function QuotaService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || QuotaService)(i0.ɵɵinject(CampaignQuotaApiService));
  };
  QuotaService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: QuotaService,
    factory: QuotaService.ɵfac,
    providedIn: 'root'
  });
  return QuotaService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TemplatesService = /*#__PURE__*/(() => {
  class TemplatesService {
    constructor(api) {
      this.api = api;
    }
    updateSMSTemplate(campaignId, templateId, name, content) {
      const req = {
        campaignId: campaignId,
        templateId: templateId,
        name: name,
        content: content
      };
      return this.api.update(req).pipe(map(() => null));
    }
  }
  TemplatesService.ɵfac = function TemplatesService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TemplatesService)(i0.ɵɵinject(TemplatesApiService));
  };
  TemplatesService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TemplatesService,
    factory: TemplatesService.ɵfac,
    providedIn: 'root'
  });
  return TemplatesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, ActivateProductForSenderRequest, ActivationService, AddContactToCampaignRequest, AddContactToCampaignResponse, AddStepToCampaignRequest, AddTagToCampaignRequest, AllDates, AsyncWorkStatus, BulkAddContactIdsToCampaignRequest, BulkAddContactsToCampaignRequest, CampaignDetailStats, CampaignQuotaCategory, CampaignRecipient, CampaignScheduleStatus, CampaignService, CampaignState, CampaignStatsService, CampaignStepEvent, CampaignStepEventType, CampaignStepInterface, CampaignStepSendStatusType, CampaignStepStats, CampaignStepType, CampaignTag, CampaignTaggingService, CheckDuplicateCampaignStatusRequest, CheckDuplicateCampaignStatusResponse, CheckDuplicateCampaignStepStatusRequest, CheckDuplicateCampaignStepStatusResponse, Colors, ConfigService, Contact, ContactType, ConvertLegacyTemplateRequest, ConvertLegacyTemplateResponse, CreateCampaignRequest, CreateCampaignResponse, CreateEmailTemplateRequest, CreateQuotaRequest, CreateRecipientCampaignStepEventRequest, CreateRecipientRequest, CreateRequest, CreateResponse, CreateTagRequest, CreateTagResponse, DateDefault, DateFilter, DaysOfTheWeek, DeactivateProductForSenderRequest, DeleteCampaignRequest, DeleteRequest, DeleteTagRequest, DeletedTagsPolicy, DuplicateAndRecommendCampaignRequest, DuplicateCampaignDetails, DuplicateCampaignRequest, DuplicateCampaignRequestV2, DuplicateCampaignResponse, DuplicateCampaignStepRequest, DuplicateCampaignStepResponse, DuplicateCampaignStepStatus, EmailBuilderConfiguration, EmailBuilderTemplate, EmailBuilderTemplateFocuses, EmailBuilderTemplateService, EmailBuilderTemplateStatuses, EmailTemplateService, EmailTemplateStruct, ExecuteStepRequest, ExportRecipientLinkClickStatsRequest, ExtractLinkTrackingDataForTemplateRequest, ExtractLinkTrackingDataForTemplateResponse, Feature, FieldMask, Filter, FilterGroup, FilterGroupOperator, FilterOperator, FilterType, FilterValue, Focuses, Footer, GetAggregatedCampaignStatsRequest, GetAggregatedCampaignStatsResponse, GetAvailableStepTypesForSenderRequest, GetAvailableStepTypesForSenderResponse, GetCampaignDetailsStatsRequest, GetCampaignDetailsStatsResponse, GetCampaignQuotaRequest, GetCampaignQuotaResponse, GetCampaignRequest, GetCampaignResponse, GetCampaignStepContentRequest, GetCampaignStepContentRequestStepDataEntry, GetCampaignStepContentResponse, GetCampaignStepStatsRequest, GetCampaignStepStatsResponse, GetConfigRequest, GetConfigResponse, GetEmailTemplateRequest, GetEmailTemplateResponse, GetEmailTemplatesRequest, GetEmailTemplatesResponse, GetLinkStatsRequest, GetLinkStatsResponse, GetMultiCampaignsRequest, GetMultiCampaignsResponse, GetRecipientCampaignRequest, GetRecipientCampaignResponse, GetRecipientLinkClickStatsRequest, GetRecipientLinkClickStatsRequestPagedRequestOptions, GetRecipientLinkClickStatsResponse, GetRecipientRequest, GetRecipientResponse, GetRequest, GetResponse, GetterCampaignData, GoogleAnalyticsOptions, ImageAlign, IsFeatureActiveForSenderRequest, IsFeatureActiveForSenderResponse, IsProductActiveForSenderRequest, IsProductActiveForSenderResponse, LegacyAddAccountGroupToCampaignRequest, LegacyAppengineService, LegacyGetRecipientCampaignsByAgidRequest, LegacyGetRecipientCampaignsByAgidResponse, LegacyPauseAccountGroupOnCampaignRequest, LegacyRateLimitedAddToCampaignRequest, LegacyRateLimitedAddToCampaignResponse, LegacyUpdateRecipientCampaignStatusRequest, LinkStats, LinkTrackingData, ListCampaignStatsForSenderRequest, ListCampaignStatsForSenderResponse, ListCampaignStatsRequest, ListCampaignStatsResponse, ListCampaignStatsStruct, ListCampaignTagDetails, ListCampaignsRequest, ListCampaignsResponse, ListCampaignsV2Request, ListCampaignsV2Response, ListLinksInTemplateRequest, ListLinksInTemplateResponse, ListRecipientCampaignsRequest, ListRecipientCampaignsResponse, ListRecipientsRequest, ListRecipientsResponse, ListRecommendedCampaignsRequest, ListTagsForCampaignRequest, ListTagsForCampaignResponse, ListTagsForSenderRequest, ListTagsForSenderResponse, LookupRecipientCampaignRequest, LookupRecipientCampaignResponse, LookupRecipientCampaignsRequest, LookupRecipientCampaignsResponse, PageSetup, PagedRequestOptions, PagedResponseMetadata, PauseCampaignRequest, PauseRecipientCampaignRequest, Period, Phone, PreviewEmailTemplateRequest, PreviewEmailTemplateResponse, QuotaService, RecipientCampaignPair, RecipientCampaignService, RecipientCampaignStatus, RecipientCampaignStepEventStruct, RecipientCampaignStruct, RecipientClickStats, RecipientClickStatsAccount, RecipientClickStatsRecipient, RecipientCriteria, RecipientType, RecipientV2, RemoveTagFromCampaignRequest, RenderRequest, RenderResponse, ResumeRecipientCampaignRequest, ScheduledCampaignStepInterface, SendCampaignStepTestEmailRequest, SendCampaignStepTestEmailRequestStepDataEntry, SendCampaignStepTestEmailResponse, SendPreviewEmailRequest, SendRecipientCampaignStepEmailRequest, Sender, SenderOptions, SenderType, SortDirection, SortField, SortOptions, Statuses, StepDataResponse, TemplateReference, TemplateStatus, TemplatesService, TopLogo, UnpauseCampaignRequest, UpdateCampaignNameRequest, UpdateConfigRequest, UpdateConfigResponse, UpdateEmailTemplateRequest, UpdateQuotaLimitRequest, UpdateRecipientRequest, UpdateRequest, UpdateStepOnCampaignRequest, UpdateTemplateRequest, UpsertCampaignRequest, UpsertConfigRequest, UpsertRecipientCampaignActivatedEventRequest, UpsertRecipientCampaignRequest, UpsertRecipientCampaignStepEventRequest };
